import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService } from '../utilities/services/api.service';
import { PopupComponent } from '@app/components/popup/popup.component';
import { ApiService as SkillCompetencyApiService } from '../../skills-competency/utilities/services/api.service';
import { ApiService as FunctionRoleApiService } from '../../functional-roles/utilities/services/api.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { TextBoxModel } from '@app/components/controls/utilities/models/text-box-model';
import { DropDownModel } from '@app/components/controls/utilities/models/drop-down-model';
import { DatePickerModel } from '@app/components/controls/utilities/models/date-picker-model';
import { ImageCropModel } from '@app/components/controls/utilities/models/image-crop-model';
import { AutoCompleteModel } from '@app/components/controls/utilities/models/auto-complete-model';
import { FileUploadModel } from '@app/components/controls/utilities/models/file-upload-model';
import { AppInitializerService } from '@app/app-initializer.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BaseService } from '@app/system/services/base.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { WeightageModel } from '@app/components/controls/utilities/models/weightage-model';
import { BuilderService } from '@app/components/controls/utilities/services/builder.service';
import { BeadComponent } from '@app/modules/knowledge-bead/bead/bead.component';
import { ResourceDetailComponent } from '@app/modules/resource/resource-detail/resource-detail.component';
import { ApiService as WorkgroupApiService } from '@app/modules/workgroup/utilities/services/api.service';
import { WorkgroupFormsComponent } from '@app/modules/workgroup/workgroup-forms/workgroup-forms.component';
import { QuillEditorModel } from '@app/components/controls/utilities/models/quill-editor-model';
import { OwlDatePickerModel } from '@app/components/controls/utilities/models/owl-date-picker-model';
import { FunctionalRolesFormsComponent } from '@app/modules/functional-roles/functional-roles-forms/functional-roles-forms.component';
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from '@angular/material/legacy-tabs';
import { PieChartModel, PieOptionsModel } from '@app/components/charts/pie-chart/pie-chart.component';
import { LineChartModel, LineOptionsModel } from '@app/components/charts/line-chart/line-chart.component';
import { ArrToStrPipe } from '@app/system/pipes/arr-to-str/arr-to-str.pipe';

@Component({
	selector: 'app-people-forms',
	templateUrl: './people-forms.component.html',
	styleUrls: ['./people-forms.component.scss']
})
export class PeopleFormsComponent implements OnInit {

	popupRef;
	action: 'create' | 'updateThumbnail' | 'addCertification' | 'addInterests' | 'endorsementDetail' | 'updateCertification' | 'update' |
		'certificationDetail' | 'endorsements' | 'feedbacks' | 'updateCompetencySKillLevel' | 'addAssessment' | 'moderateCertification' | 'workgroupProcess' | 'inviteUser' |
		'userFilter' | 'assignSkill' | 'import_users';
	loader = false;
	submitDisable = true;
	formFields: any = [];
	config = { fxFlex: 100 };
	title;
	formObject;
	info = '';
	helpTriggered = false;
	thumbnail;
	currentUser;
	clearTimeout;
	userID;
	record;
	certificationData = [];
	endorsementManagersData = [];
	endorsementPeersData = [];
	validationRegex = new RegExp('^(https?:\/\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\/\/(?:www\\.|(?!www))[a-zA-Z0-9]+\\.[^\s]{2,}|www\\.[a-zA-Z0-9]+\.[^\\s]{2,})$', 'gi');
	// validationRegex = new RegExp('/^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z00a1-ffff0-9]-*)*[a-z00a1-ffff0-9]+)(?:\.(?:[a-z00a1-ffff0-9]-*)*[a-z00a1-ffff0-9]+)*(?:\.(?:[a-z00a1-ffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/g');
	embedData;
	titleField;
	data;
	tabIndex = 0;
	feedbackData = [];
	totalRecordCount = 0;
	competencyData;
	assessmentData = [];
	sharingData = [];
	endorsementData = [];
	userData;
	workgroupData = [];
	certificateFormObject;
	deviceDetails;
	functionalRole: DropDownModel;
	emailID: AutoCompleteModel;
	description: QuillEditorModel;
	location: AutoCompleteModel;
	department: AutoCompleteModel;
	city: AutoCompleteModel
	permissionGroup: DropDownModel;
	formObjectData = {
		form: null,
		fields: []
	};
	showCertificateModeration = false;
	tabKey;
	tabArr = [];
	subscribes;
	assignCompetencyData;
	updatedCompetencyData: any;
	assignForm : UntypedFormGroup;
	analyticsData;
	sampleExcel=false

	constructor(
		private apiService: ApiService,
		public gfService: GlobalFunctionService,
		public locale: LocaleService,
		private popup: MatDialog,
		private globalApiService: GlobalApiService,
		private appInit: AppInitializerService,
		private skillCompetencyApiService: SkillCompetencyApiService,
		private functionRoleApiService: FunctionRoleApiService,
		private baseService: BaseService,
		public detectDevice: DetectDeviceService,
		private builderService: BuilderService,
		private workgroupApiService: WorkgroupApiService,
		private cdref: ChangeDetectorRef,
		private arrToStr: ArrToStrPipe,
		
	) {
		this.currentUser = gfService.sessionUser;
	}

	ngOnInit(): void {
		this.showCertificateModeration = this.baseService.checkAccessControl('RES004') && this.userID !== this.currentUser.userID;
		this.deviceDetails = this.detectDevice.fingerPrint;
		if (!['certificationDetail', 'endorsements', 'feedbacks', 'updateCompetencySKillLevel', 'workgroupProcess', 'assignSkill'].includes(this.action)) {
			this.baseService.formView = true;
		}
		if (this.action === 'create') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			this.title = this.locale.translate('new_user');
			const firstName: TextBoxModel = {
				fieldColumn: 'firstName',
				fieldCaption: this.locale.translate('first_name'),
				additionalMetaData: {
					maxChar: 150,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('first_name'),
				type: 'text'
			};
			const lastName: TextBoxModel = {
				fieldColumn: 'lastName',
				fieldCaption: this.locale.translate('last_name'),
				additionalMetaData: {
					maxChar: 150,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('last_name'),
				type: 'text'
			};
			const emailID: TextBoxModel = {
				fieldColumn: 'emailID',
				fieldCaption: this.locale.translate('email_id'),
				additionalMetaData: {
					maxChar: 50,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'email',
				validationRegex: '^[A-Za-z0-9.+_-]+@[A-Za-z0-9.+_-]+.[A-Za-z]{2,4}$',
				fieldPlaceholder: this.locale.translate('email_id'),
				validationMessage: this.locale.translate('enter_valid_email_id'),
				value: null
			};
			const mobileNo: TextBoxModel = {
				fieldColumn: 'mobileNo',
				fieldCaption: this.locale.translate('mobile_number_include_country_code'),
				additionalMetaData: {
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				type: 'text',
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('mobile_number_include_country_code'),
				value: null
			};
			const gender: DropDownModel = {
				fieldColumn: 'gender',
				fieldType: 'dropDown',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {},
				fieldCaption: this.locale.translate('gender'),
				fieldPlaceholder: this.locale.translate('gender'),
				value: null
			};
			const dateOfBirth: DatePickerModel = {
				fieldColumn: 'dateOfBirth',
				additionalMetaData: {
					maxDate: 0
				},
				fieldType: 'date',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				fieldCaption: this.locale.translate('date_of_birth'),
				fieldPlaceholder: this.locale.translate('date_of_birth'),
				value: null
			};
			const dateOfJoining: DatePickerModel = {
				fieldColumn: 'dateOfJoining',
				additionalMetaData: {
					maxDate: 0
				},
				fieldType: 'date',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				fieldCaption: this.locale.translate('date_of_joining'),
				fieldPlaceholder: this.locale.translate('date_of_joining'),
				value: null
			};
			const yearsOfExp: TextBoxModel = {
				fieldColumn: 'experienceAtJoining',
				fieldCaption: this.locale.translate('years_of_experience_as_of_doj'),
				additionalMetaData: {
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				type: 'text',
				validationRegex:
					'([0-9]{1,2})?(.?((0?[0-9])|(1[01])))',
				fieldPlaceholder: this.locale.translate('years_of_experience_as_of_doj'),
				fieldHelpText: this.locale.translate('enter_in_years_month_format'),
				validationMessage: this.locale.translate('enter_in_years_month_format'),
				value: null
			};
			const designation: AutoCompleteModel = {
				fieldColumn: 'designation',
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: false,
				options: [],
				additionalMetaData: {
					autoFill: 'off'
				},
				fieldCaption: this.locale.translate('designation'),
				fieldPlaceholder: this.locale.translate('designation'),
				value: null,
				selectedValue: [],
				preDefined: false
			};
			const department: AutoCompleteModel = {
				fieldColumn: 'department',
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				additionalMetaData: {
					autoFill: 'off',
					max: 1
				},
				fieldCaption: this.locale.translate('department'),
				fieldPlaceholder: this.locale.translate('department'),
				value: null,
				selectedValue: [],
				preDefined: false
			};
			const location: AutoCompleteModel = {
				fieldColumn: 'location',
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				additionalMetaData: {
					autoFill: 'off',
					max: 1
				},
				fieldCaption: this.locale.translate('location'),
				fieldPlaceholder: this.locale.translate('location'),
				value: null,
				selectedValue: [],
				preDefined: false
			};

			const city: AutoCompleteModel = {
				fieldColumn: 'city',
				fieldType: 'autoComplete',
				isHidden: true,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {
					autoFill: 'off',
					max: 1
				},
				fieldCaption: this.locale.translate('city'),
				fieldPlaceholder: this.locale.translate('city'),
				value: null,
				selectedValue: [],
				preDefined: true
			};

			this.functionalRole = {
				fieldColumn: 'functionRole',
				fieldType: 'dropDown',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {},
				fieldCaption: this.locale.translate('functional_role'),
				fieldPlaceholder: this.locale.translate('functional_role'),
				value: null
			};

			this.permissionGroup = {
				fieldColumn: 'permissionGroupID',
				fieldType: 'dropDown',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {},
				fieldCaption: this.locale.translate('permission_group'),
				fieldPlaceholder: this.locale.translate('permission_group'),
				value: null
			};

			this.formFields = [
				firstName,
				lastName,
				emailID,
				mobileNo,
				gender,
				dateOfBirth,
				dateOfJoining,
				yearsOfExp,
				designation,
				department,
				location,
				city,
				this.functionalRole,
				this.permissionGroup
			];
			this.submitDisable = false;
			if (this.helpTriggered) {
				this.loader = false;
			} else {
				this.popupRef.componentInstance.popupLoader = false;
			}

			// gender.options = [
			// 	{
			// 		key: 1,
			// 		value: this.locale.translate('male')
			// 	},
			// 	{
			// 		key: 2,
			// 		value: this.locale.translate('female')
			// 	}
			// ];
			const genderApiData = {
				termsetid: 11
			};
			const genderHeaders: any = {};
			this.globalApiService.getTerm(genderApiData, genderHeaders).subscribe(
				(response) => {
					if (response && response.records.length) {
						gender.options = response.records.map(resp => {
							return {
								key: resp.termID,
								value: resp.term
							};
						});
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => { });

			this.loadDesignation(designation);

			this.loadFunctionalRole();

			this.loadPermissionGroup();
		} else if (this.action === 'updateThumbnail') {
			this.title = this.locale.translate('updateThumbnail');
			const profilePic: ImageCropModel = {
				fieldColumn: 'profilePic',
				fieldCaption: this.locale.translate('profile_picture'),
				additionalMetaData: {
					cropBoxResizable: false,
					dragMode: 'move',
					showBackground: true,
					dragType: 'round',
					zoom: true,
					width: 110,
					height: 110,
					toggleDragModeOnDblclick: false,
					showLabel: false,
					dataUrl: false,
					showUploadIcon: true
				},
				fieldType: 'imageCrop',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				value: {
					imageSrc: this.thumbnail
				},
				fieldPlaceholder: this.locale.translate('profile_picture')
			};
			this.formFields = [profilePic];
			this.submitDisable = false;
			this.loader = false;
		} else if (this.action === 'addCertification' || this.action === 'updateCertification') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			if (this.action === 'addCertification') {
				this.title = this.locale.translate('register_learning');
			} else if (this.action === 'updateCertification') {
				this.title = this.locale.translate('edit_certification');
			}

			this.titleField = {
				fieldColumn: 'title',
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				fieldCaption: this.locale.translate('certification_title_url'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('certification_title_url')
			};

			const activityType: DropDownModel = {
				fieldColumn: 'activityType',
				fieldType: 'dropDown',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {},
				fieldCaption: this.locale.translate('activity_type'),
				fieldPlaceholder: this.locale.translate('activity_type'),
				value: null
			};

			activityType.options = [{
				key: 1,
				value: 'MOOC'
			}, {
				key: 2,
				value: 'Event'
			}];

			const issuingAuthority: AutoCompleteModel = {
				fieldColumn: 'issuingAuthority',
				additionalMetaData: {
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					max: 1
				},
				fieldType: 'autoComplete',
				isHidden: true,
				isReadonly: false,
				isRequired: true,
				validationRegex: null,
				fieldCaption: this.locale.translate('issuing_authority'),
				fieldHelpText: null,
				fieldOrder: 4,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('issuing_authority'),
				preDefined: false,
				isMultiple: true,
				options: [],
				selectedValue: []
			};

			const date: OwlDatePickerModel = {
				fieldColumn: 'date',
				additionalMetaData: {
					// maxDate: 0,
					showLabel: true,
					pickerType: 'calendar',
				},
				fieldType: 'owlDate',
				isHidden: true,
				isReadonly: false,
				isRequired: true,
				fieldCaption: this.locale.translate('date'),
				fieldOrder: 4,
				fieldPlaceholder: this.locale.translate('date')
			};

			const skills: AutoCompleteModel = {
				fieldColumn: 'skills',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					defaultWeightage: 1,
					minWeightage: 1,
					showHelp: true,
					max: 3
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('what_skill_does_this_cover_desc'),
				fieldOrder: 5,
				preDefined: false,
				fieldPlaceholder: this.locale.translate('search_skills'),
				type: 'weightage'
			};

			const evidence: FileUploadModel = {
				fieldCaption: this.locale.translate('please_share_certificate'),
				fieldColumn: 'evidence',
				validationMessage: this.locale.translate('invalid_file'),
				fieldOrder: 6,
				fieldType: 'fileUpload',
				fieldHelpText: null,
				fieldPlaceholder: this.locale.translate('choose_file'),
				isRequired: true,
				isHidden: false,
				additionalMetaData: {
					showLabel: true,
					fileSize: '5MB',
					supportedType: ['.jpeg', '.png', '.pdf', '.jpg'],
					drag: true
				},
				isReadonly: false,
				value: null
			};
			if (this.currentUser.weightageData) {
				skills.additionalMetaData.maxWeightage = this.currentUser.weightageData.map((data) => {
					return {
						key: data.termID,
						value: data.term,
						weightage: data.index,
						description: data.attributes.description
					};
				});
			}
			const workgroupHeaders: any = {};
			let tagUser: AutoCompleteModel;
			this.workgroupApiService.getJoinedWGList(workgroupHeaders).subscribe(
				(workgroupResponse) => {
					if (workgroupResponse && workgroupResponse.records && workgroupResponse.records.length) {
						tagUser = null;
					} else {
						tagUser = {
							fieldColumn: 'taggedUsers',
							additionalMetaData: {
								showLabel: true,
								autoFill: 'off'
							},
							fieldType: 'autoComplete',
							isHidden: false,
							isMultiple: true,
							isReadonly: false,
							isRequired: false,
							options: [],
							selectedValue: [],
							fieldCaption: this.locale.translate('tag_your_managers_supervisors'),
							fieldOrder: 3,
							preDefined: true,
							fieldPlaceholder: this.locale.translate('search_users'),
							type: 'general'
						};
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			).add(() => {
				if (this.action === 'updateCertification') {
					const headers: any = {};
					this.apiService.getCertificationDetail({}, this.record.registerLearningID, headers).subscribe(
						(response) => {
							if (response) {
								this.titleField.value = response.title;
								issuingAuthority.value = response.issuingAuthority;
								if (response.skills && response.skills.length) {
									skills.selectedValue = response.skills.map(resp => {
										resp.termID = resp.skill;
										return {
											weightage: resp.skillLevel,
											key: resp,
											value: resp.skillName,
											isDelete: false,
											isAdd: true
										};
									});
									skills.value = skills.selectedValue;
								}
								evidence.value = {
									name: response.evidence
								};
								evidence.additionalMetaData.thumbnail = response.thumbnail;

								if (response.activityType) {
									if (response.activityType === 1) {
										issuingAuthority.isHidden = false;
									} else {
										date.isHidden = false;
									}
								}

								if (response.issuingAuthority) {
									issuingAuthority.value = response.issuingAuthority;
								}

								if (response.date) {
									date.value = new Date(response.date);
								}
							}
						},
						(error) => {
							this.gfService.errorHandler(error, {
								snackBar: {
									position: 'before'
								}
							});
						}
					)
						.add(() => {
							this.submitDisable = false;
							if (this.helpTriggered) {
								this.loader = false;
							} else {
								this.popupRef.componentInstance.popupLoader = false;
							}
							this.formFields = [
								activityType,
								issuingAuthority,
								date,
								skills,
								evidence
							];
							if (tagUser) {
								this.formFields.push(tagUser);
							}
						});
				} else {
					if (this.record) {
						if (this.record.activityType) {
							activityType.value = this.record.activityType;
							if (activityType.value === 1) {
								issuingAuthority.isHidden = false;
								issuingAuthority.isRequired = true;
							} else {
								date.isHidden = false;
								date.isRequired = true;
							}
						}
						if (this.record.issuingAuthority) {
							issuingAuthority.selectedValue = [
								{
									isAdd: true,
									isDelete: false,
									value: this.record.issuingAuthority
								}
							];
							issuingAuthority.value = issuingAuthority.selectedValue;
						}
						if (this.record.date) {
							date.value = new Date(this.record.date);
						}
						if (this.record.title) {
							this.titleField.value = this.record.title;
						}
						if (this.record.skills && this.record.skills.length) {
							skills.selectedValue = this.record.skills.map(skill => {
								return {
									isAdd: true,
									isDelete: false,
									key: {
										termID: skill.skill.key
									},
									value: skill.skill.value,
									weightage: skill.skillLevel
								};
							});
							skills.value = skills.selectedValue;
						}
					}
					if (!skills.selectedValue || !skills.selectedValue.length) {
						this.loadMySkills(skills);
					}
					this.formFields = [
						activityType,
						issuingAuthority,
						date,
						skills,
						evidence
					];
					if (tagUser) {
						this.formFields.push(tagUser);
					}
					this.submitDisable = false;
					if (this.helpTriggered) {
						this.loader = false;
					} else {
						this.popupRef.componentInstance.popupLoader = false;
					}
				}
			});

		} else if (this.action === 'certificationDetail') {
			this.title = this.locale.translate('register_learning');
			this.popupRef.componentInstance.popupLoader = true;
			const headers: any = {};
			this.apiService.getCertificationDetail({}, this.record.registerLearningID, headers).subscribe(
				(response) => {
					if (response) {
						response.status = this.baseService.referenceType('certificationStatus', response.status);
						this.data = response;
						this.record.userID = response.userID;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.popupRef.componentInstance.popupLoader = false;
				});
		} else if (this.action === 'addInterests') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			this.title = this.locale.translate('add_interests');
			const skills: AutoCompleteModel = {
				fieldColumn: 'skills',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					showHelp: true,
					max: 3
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('what_skill_does_this_cover_desc'),
				fieldOrder: 3,
				preDefined: false,
				fieldPlaceholder: this.locale.translate('search_skills')
			};

			this.formFields = [
				skills
			];
			// this.loadMySkills(skills);
			this.submitDisable = false;
			if (this.helpTriggered) {
				this.loader = false;
			} else {
				this.popupRef.componentInstance.popupLoader = false;
			}
		} else if (this.action === 'update') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			this.title = this.locale.translate('edit_user');
			const firstName: TextBoxModel = {
				fieldColumn: 'firstName',
				fieldCaption: this.locale.translate('first_name'),
				additionalMetaData: {
					maxChar: 150,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('first_name'),
				type: 'text'
			};
			const lastName: TextBoxModel = {
				fieldColumn: 'lastName',
				fieldCaption: this.locale.translate('last_name'),
				additionalMetaData: {
					maxChar: 150,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('last_name'),
				type: 'text'
			};
			const emailID: TextBoxModel = {
				fieldColumn: 'emailID',
				fieldCaption: this.locale.translate('email_id'),
				additionalMetaData: {
					maxChar: 50,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: true,
				isRequired: true,
				type: 'email',
				validationRegex: '^[A-Za-z0-9.+_-]+@[A-Za-z0-9.+_-]+.[A-Za-z]{2,4}$',
				fieldPlaceholder: this.locale.translate('email_id'),
				validationMessage: this.locale.translate('enter_valid_email_id'),
				value: null
			};
			const mobileNo: TextBoxModel = {
				fieldColumn: 'mobileNo',
				fieldCaption: this.locale.translate('mobile_number_include_country_code'),
				additionalMetaData: {
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				type: 'text',
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('mobile_number_include_country_code'),
				value: null
			};
			const gender: DropDownModel = {
				fieldColumn: 'gender',
				fieldType: 'dropDown',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {},
				fieldCaption: this.locale.translate('gender'),
				fieldPlaceholder: this.locale.translate('gender'),
				value: null
			};
			const dateOfBirth: DatePickerModel = {
				fieldColumn: 'dateOfBirth',
				additionalMetaData: {
					maxDate: 0
				},
				fieldType: 'date',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				fieldCaption: this.locale.translate('date_of_birth'),
				fieldPlaceholder: this.locale.translate('date_of_birth'),
				value: null
			};
			const dateOfJoining: DatePickerModel = {
				fieldColumn: 'dateOfJoining',
				additionalMetaData: {
					maxDate: 0
				},
				fieldType: 'date',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				fieldCaption: this.locale.translate('date_of_joining'),
				fieldPlaceholder: this.locale.translate('date_of_joining'),
				value: null
			};
			const yearsOfExp: TextBoxModel = {
				fieldColumn: 'experienceAtJoining',
				fieldCaption: this.locale.translate('years_of_experience_as_of_doj'),
				additionalMetaData: {
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				type: 'text',
				validationRegex:
					'([0-9]{1,2})?(.?((0?[0-9])|(1[01])))',
				fieldPlaceholder: this.locale.translate('years_of_experience_as_of_doj'),
				fieldHelpText: this.locale.translate('enter_in_years_month_format'),
				validationMessage: this.locale.translate('enter_in_years_month_format'),
				value: null
			};
			const designation: AutoCompleteModel = {
				fieldColumn: 'designation',
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: false,
				options: [],
				additionalMetaData: {
					autoFill: 'off'
				},
				fieldCaption: this.locale.translate('designation'),
				fieldPlaceholder: this.locale.translate('designation'),
				value: null,
				selectedValue: [],
				preDefined: false
			};
			const department: AutoCompleteModel = {
				fieldColumn: 'department',
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				additionalMetaData: {
					autoFill: 'off',
					max: 1
				},
				fieldCaption: this.locale.translate('department'),
				fieldPlaceholder: this.locale.translate('department'),
				value: null,
				selectedValue: [],
				preDefined: false
			};
			const location: AutoCompleteModel = {
				fieldColumn: 'location',
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				additionalMetaData: {
					autoFill: 'off',
					max: 1
				},
				fieldCaption: this.locale.translate('location'),
				fieldPlaceholder: this.locale.translate('location'),
				value: null,
				selectedValue: [],
				preDefined: false
			};
			const city: AutoCompleteModel = {
				fieldColumn: 'city',
				fieldType: 'autoComplete',
				isHidden: true,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {
					autoFill: 'off',
					max: 1
				},
				fieldCaption: this.locale.translate('city'),
				fieldPlaceholder: this.locale.translate('city'),
				value: null,
				selectedValue: [],
				preDefined: true
			};
			this.functionalRole = {
				fieldColumn: 'functionRole',
				fieldType: 'dropDown',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {},
				fieldCaption: this.locale.translate('functional_role'),
				fieldPlaceholder: this.locale.translate('functional_role'),
				value: null
			};

			this.permissionGroup = {
				fieldColumn: 'permissionGroupID',
				fieldType: 'dropDown',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {},
				fieldCaption: this.locale.translate('permission_group'),
				fieldPlaceholder: this.locale.translate('permission_group'),
				value: null
			};

			firstName.value = this.record.firstName;
			lastName.value = this.record.lastName;
			emailID.value = this.record.emailID;
			mobileNo.value = this.record.mobileNO;
			if (this.record.gender && this.record.gender.ID) {
				gender.value = this.record.gender.ID;
			}
			if (this.record.dateOfBirth) {
				dateOfBirth.value = new Date(this.record.dateOfBirth);
			}
			if (this.record.dateOfJoining) {
				dateOfJoining.value = new Date(this.record.dateOfJoining);
			}
			if (this.record.designation && this.record.designation.ID) {
				designation.value =
				{
					isAdd: true,
					isDelete: false,
					key: this.record.designation.ID,
					value: this.record.designation.name
				}
				designation.selectedValue = [designation.value];
			}
			if (this.record.department && this.record.department.ID) {
				department.value =
				{
					isAdd: true,
					isDelete: false,
					key: this.record.department.ID,
					value: this.record.department.name
				}
				department.selectedValue = [department.value];
			}
			if (this.record.location && this.record.location.ID) {
				const value = [];
				value.push(this.record.location.name);
				if (this.record.city) {
					if (this.record.city.name) {
						value.push(` ${this.record.city.name}`)
					}
				}
				if (this.record.country) {
					if (this.record.country.name) {
						value.push(` ${this.record.country.name}`)
					}
				}
				location.value = {
					isAdd: true,
					isDelete: false,
					key: this.record.location.ID,
					value: value.toString()
				};
				location.selectedValue = [location.value];
			}
			if (this.record.functionRole && this.record.functionRole.ID) {
				this.functionalRole.value = this.record.functionRole.ID;
			}
			if (this.record.permissionGroup && this.record.permissionGroup.ID) {
				this.permissionGroup.value = this.record.permissionGroup.ID;
			}
			if (this.record.experienceAtJoining) {
				const year = Math.floor(this.record.experienceAtJoining / 12);
				const yearToMonth = year * 12;
				const result = ((this.record.experienceAtJoining - yearToMonth) * 0.01) + year;
				yearsOfExp.value = this.gfService.precisionRoundFloat(result);
			}
			this.formFields = [
				firstName,
				lastName,
				emailID,
				mobileNo,
				gender,
				dateOfBirth,
				dateOfJoining,
				yearsOfExp,
				designation,
				department,
				location,
				city,
				this.functionalRole,
				this.permissionGroup
			];
			this.submitDisable = false;
			if (this.helpTriggered) {
				this.loader = false;
			} else {
				this.popupRef.componentInstance.popupLoader = false;
			}

			// gender.options = [
			// 	{
			// 		key: 8,
			// 		value: this.locale.translate('male')
			// 	},
			// 	{
			// 		key: 9,
			// 		value: this.locale.translate('female')
			// 	}
			// ];
			const genderApiData = {
				termsetid: 11
			};
			const genderHeaders: any = {};
			this.globalApiService.getTerm(genderApiData, genderHeaders).subscribe(
				(response) => {
					if (response && response.records.length) {
						gender.options = response.records.map(resp => {
							return {
								key: resp.termID,
								value: resp.term
							};
						});
					}
				},
				(error) => {

					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => { });

			this.loadFunctionalRole();
			this.loadPermissionGroup();
		} else if (this.action === 'endorsements') {
			this.title = this.locale.translate('skill_board');
			this.tabKey = 'managers';
			this.getEndorsementDataForCompetency(this.tabKey);
			this.tabArr = [
				// {assigned_info_text
				// 	key: 'assessments',
				// 	caption: this.locale.translate('assessments')
				// }
			];
			this.info = this.locale.translate('assigned_info_text');
			if (this.baseService.checkAccessControl('MU001') || this.userID === this.currentUser.userID) {
				this.tabArr.push({
					key: 'managers',
					caption: this.locale.translate('managers')
				});
			}

			if (this.baseService.checkAccessControl('MU001') || this.userID === this.currentUser.userID) {
				this.tabArr.push({
					key: 'peers',
					caption: this.locale.translate('peers')
				});
			}
			this.tabArr.push({
				key: 'certifications',
				caption: this.locale.translate('certifications')
			}, {
				key: 'sharing',
				caption: this.locale.translate('sharing')
			});
			if (this.record){
				this.title = this.locale.translate('skill_board');
			}
				if (this.baseService.checkAccessControl('MU001') || this.userID === this.currentUser.userID) {
					this.tabArr.push({
						key: 'assessments',
						caption: this.locale.translate('assigned')
					});
				}
				this.getUserAnalytics()
			
		} else if (this.action === 'feedbacks') {
			this.title = this.locale.translate('feedbacks');
			this.popupRef.componentInstance.popupLoader = true;
			this.feedbackData = [];
			this.getFeedback(1);
		} else if (this.action === 'updateCompetencySKillLevel') {
			this.title = this.locale.translate('competencies');
			this.popupRef.componentInstance.popupLoader = true;
			const headers: any = {};
			this.apiService.userCompetency(this.userID, headers).subscribe(
				(response) => {
					if (response) {
						this.dataBuild(response, 'competency');
						this.competencyData = response;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.popupRef.componentInstance.popupLoader = false;
				});
		} else if (this.action === 'addAssessment') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			this.title = this.locale.translate('internal_assessment');
			const title: TextBoxModel = {
				fieldColumn: 'title',
				fieldCaption: this.locale.translate('assessment_title'),
				additionalMetaData: {
					maxChar: 150,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('assessment_title'),
				type: 'text'
			};
			const date: DatePickerModel = {
				fieldColumn: 'timeStamp',
				additionalMetaData: {
					minDate: 0
				},
				fieldType: 'date',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				fieldCaption: this.locale.translate('date'),
				fieldPlaceholder: this.locale.translate('date'),
				value: null
			};
			const skills: AutoCompleteModel = {
				fieldColumn: 'skills',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					defaultWeightage: 1,
					minWeightage: 1,
					showHelp: true
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('resultant_skill_levels'),
				fieldOrder: 3,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('search_skills'),
				type: 'weightage'
			};
			if (this.currentUser.weightageData) {
				skills.additionalMetaData.maxWeightage = this.currentUser.weightageData.map((data) => {
					return {
						key: data.termID,
						value: data.term,
						weightage: data.index,
						description: data.attributes.description
					};
				});
			}
			this.formFields = [
				title,
				date,
				skills
			];
			this.submitDisable = false;
			if (this.helpTriggered) {
				this.loader = false;
			} else {
				this.popupRef.componentInstance.popupLoader = false;
			}
		} else if (this.action === 'moderateCertification') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			this.title = this.locale.translate('moderation');
			this.info = this.locale.translate('this_require_moderation_but_your_not_workgroup_desc');
			const users: AutoCompleteModel = {
				fieldColumn: 'users',
				additionalMetaData: {
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					autoFill: 'off',
					max: 1
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				validationRegex: null,
				fieldCaption: this.locale.translate('name'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('type_name'),
				isMultiple: true,
				options: [],
				selectedValue: [],
				preDefined: true
			};
			this.formFields = [
				users
			];
			if (this.data) {
				this.certificateFormObject = this.data.formObject;
				this.embedData = this.data.embedData;
			}
			this.submitDisable = false;
			if (this.helpTriggered) {
				this.loader = false;
			} else {
				this.popupRef.componentInstance.popupLoader = false;
			}
		} else if (this.action === 'workgroupProcess') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			const headers: any = {};
			const apiData = {};
			this.workgroupApiService.getList(apiData, headers).subscribe(
				(response) => {
					if (response && response.records && response.records.length) {
						this.workgroupData = response.records;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					if (this.helpTriggered) {
						this.loader = false;
					} else {
						this.popupRef.componentInstance.popupLoader = false;
					}
					this.submitDisable = false;
				});
		} else if (this.action === 'inviteUser') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			this.title = this.locale.translate('invite_users');
			// this.emailID = {
			// 	fieldColumn: 'emailID',
			// 	fieldCaption: this.locale.translate('email_id'),
			// 	additionalMetaData: {
			// 		maxChar: 50,
			// 		fieldConfig: {
			// 			appearance: 'standard',
			// 			floatLabel: 'auto'
			// 		}
			// 	},
			// 	fieldType: 'textBox',
			// 	isHidden: false,
			// 	isReadonly: false,
			// 	isRequired: true,
			// 	type: 'text',
			// 	validationRegex: '^(([A-Za-z0-9.+-]+)@([A-Za-z0-9.+-]+)[.]([A-Za-z]{2,4}))?([ ]{1,1}(([A-Za-z0-9.+-]+)@([A-Za-z0-9.+-]+)[.]([A-Za-z]{2,4})))*$',
			// 	fieldPlaceholder: this.locale.translate('email_id'),
			// 	validationMessage: `${this.locale.translate('enter_valid')} ${this.locale.translate('email_id')}`,
			// 	value: null
			// };
			this.emailID = {
				fieldColumn: 'emailID',
				fieldCaption: this.locale.translate('email_ids'),
				additionalMetaData: {
					loadOptions: false,
					max: 10
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				preDefined: false,
				type: 'general',
				options: [],
				selectedValue: [],
				validationRegex: '^([A-Za-z0-9.+-]+)@([A-Za-z0-9.+-]+)[.]([A-Za-z]{2,4})$',
				fieldPlaceholder: this.locale.translate('email_ids'),
				validationMessage: this.locale.translate('enter_valid_email_id'),
				value: null
			};
			this.functionalRole = {
				fieldColumn: 'functionalRoleID',
				fieldType: 'dropDown',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {},
				fieldCaption: this.locale.translate('functional_role'),
				fieldPlaceholder: this.locale.translate('functional_role'),
				value: null
			};

			this.department = {
				fieldColumn: 'department',
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				additionalMetaData: {
					autoFill: 'off',
					max: 1
				},
				fieldCaption: this.locale.translate('department'),
				fieldPlaceholder: this.locale.translate('department'),
				value: null,
				selectedValue: [],
				preDefined: false
			};

			this.location = {
				fieldColumn: 'location',
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				additionalMetaData: {
					autoFill: 'off',
					max: 1
				},
				fieldCaption: this.locale.translate('location'),
				fieldPlaceholder: this.locale.translate('location'),
				value: null,
				selectedValue: [],
				preDefined: false
			};

			this.city = {
				fieldColumn: 'city',
				fieldType: 'autoComplete',
				isHidden: true,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {
					autoFill: 'off',
					max: 1
				},
				fieldCaption: this.locale.translate('city'),
				fieldPlaceholder: this.locale.translate('city'),
				value: null,
				selectedValue: [],
				preDefined: true
			};

			this.description = {
				fieldCaption: this.locale.translate('page'),
				fieldColumn: 'message',
				validationRegex: '',
				validationMessage: '',
				fieldOrder: 1,
				fieldType: 'quillEditor',
				fieldHelpText: '',
				isRequired: false,
				isHidden: false,
				additionalMetaData: {
					// height: 400,
					showLabel: false,
					imageUploadData: {
						fileSize: '10MB',
						supportedType: ['.jpg', '.jpeg', '.png', '.gif'],
						url: ''
					},
					config: {
						// toolbar: [
						// 	['link', 'image', 'video', 'formula', 'code-block']
						// ],
						toolbar: false,
						// toolbar: '#toolbar-container',
						formula: true,
						imageResize: true
					}
				},
				isReadonly: false,
				value: null,
				fieldPlaceholder: this.locale.translate('type_a_message')
			};

			this.permissionGroup = {
				fieldColumn: 'permissionGroupID',
				fieldType: 'dropDown',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {},
				fieldCaption: this.locale.translate('permission_group'),
				fieldPlaceholder: this.locale.translate('permission_group'),
				value: null
			};

			this.submitDisable = false;
			if (this.helpTriggered) {
				this.loader = false;
			} else {
				this.popupRef.componentInstance.popupLoader = false;
			}
			this.loadFunctionalRole();
			this.loadPermissionGroup();
		} else if (this.action === 'userFilter') {
			// if (this.helpTriggered) {
			// 	this.loader = true;
			// } else {
			// 	this.popupRef.componentInstance.popupLoader = true;
			// }
			this.title = this.locale.translate('status');
		} else if (this.action === 'assignSkill') {
			// const header: any = {};
			// this.apiService.userSkillCompetency(this.userID, header).subscribe(
			// 	(response) => {
			// 		if (response && response.records) {
			// 			this.updatedCompetencyData =  response.records;
			// 			console.log(this.updatedCompetencyData, "this.updatedCompetencyData>>>>>>")
			// 		}
			// 	},
			// 	(error) => {
			// 		this.gfService.errorHandler(error, {
			// 			snackBar: {
			// 				position: 'before'
			// 			}
			// 		});
			// 	}
			// )
			this.title = this.locale.translate('assign') + ' ' +this.locale.translate('skills');
			this.popupRef.componentInstance.popupLoader = true;
			const headers: any = {};
			this.apiService.userCompetency(this.userID, headers).subscribe(
				(response) => {
					if (response) {
						this.popupRef.componentInstance.popupLoader = true;
						this.dataBuild(response, 'competency');
						this.competencyData = response;
						this.popupRef.componentInstance.popupLoader = false;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					// this.popupRef.componentInstance.popupLoader = false;
					this.submitDisable = false;
				});
		}
	}

	async download() {
		const fileUrl = 'https://d274n8qygbtr9q.cloudfront.net/biliti_dev/dev/document/50cc5fc6-df44-4459-a3ab-8d0367d2a193.xls'; // Replace with your file URL
	
		try {
			const response = await fetch(fileUrl);
			const blob = await response.blob();
			const link = document.createElement('a');
			link.href = URL.createObjectURL(blob);
			link.download = 'sample_import_user.xlsx'; // Specify the file name
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error('Error downloading the file:', error);
		}
	}

	getEndorsementCertifyCount(event, data) {
		if (event && !data.counted && navigator.onLine) {
			data.loader = true;
			const apiData = {
				userID: this.userID,
				roleID: this.competencyData.roleID,
				competencyID: data.ID
			};
			const headers: any = {};
			this.apiService.getEndorsementCertifyCount(apiData, headers).subscribe(
				(response) => {
					if (response) {
						data.certificationsCount = response.certificationsCount;
						data.managersCount = response.managersCount;
						data.peersCount = response.peersCount;
						data.counted = true;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					data.loader = false;
				});
		}
	}

	endorsementsForCompetency(tabIndex, data, additionalInfo: any = {}) {
		if (additionalInfo.count && navigator.onLine) {
			data.roleID = this.competencyData.roleID;
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				data: {
					action: 'dynamic',
					popup: true,
					component: PeopleFormsComponent,
					componentData: [
						{
							variableName: 'action',
							value: 'endorsements'
						},
						{
							variableName: 'userID',
							value: this.userID
						},
						{
							variableName: 'tabIndex',
							value: tabIndex
						},
						{
							variableName: 'record',
							value: data
						}
					]
				},
				disableClose: true,
				maxWidth: '860px'
			});
			dialogRef.afterClosed().subscribe((result) => {
				if (result && typeof result === 'object') {

				}
			});
		}
	}

	dataBuild(data, action: 'competency' | 'sharing') {
		if (action === 'competency') {
			// Assign skill form
			const title: TextBoxModel = {
				fieldColumn: 'title',
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				fieldCaption: this.locale.translate('title'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('title')
			};

			let skillLevelData = [];
			if (this.currentUser.weightageData) {
				skillLevelData = this.currentUser.weightageData.map((data) => {
					return {
						key: data.termID,
						value: data.term,
						weightage: data.index,
						description: data.attributes.description
					};
				});
			}
			
			if (data.otherSkills && data.otherSkills.length) {
				for (const skill of data.otherSkills) {
					let value = null; //skill.skillLevel;
					// if (this.updatedCompetencyData) {
					// 	value = this.updatedCompetencyData.find((items => items.skillID === skill.ID))
					// } else {
					// 	value = null; 
					// }
					const weightage: WeightageModel = {
						fieldCaption: skill.Name,
						fieldColumn: skill.ID,
						additionalMetaData: {
							maxWeightage: skillLevelData,
							// minWeightage: 1,
							showHelp: true,
							expectedWeightage: null,
							defaultWeightage: 0
						},
						fieldType: 'weightage',
						isHidden: false,
						isReadonly: false,
						isRequired: false,
						value
					};
					skill.field = weightage;
					this.builderService.fieldModelBuilder(weightage);
					const control: UntypedFormControl = this.builderService.controlBuilder(weightage);
					skill.control = control;
					control.valueChanges.subscribe(controlResp => {
						this.updateSkill(skill.ID, controlResp);
					});
				}
			}
			if (data.competencies && data.competencies.length) {
				for (const competency of data.competencies) {
					competency.loader = false;
					let totalSkill = 0;
					if (competency.skills && competency.skills.length) {
						for (const skill of competency.skills) {
							let expected = Number(skill.expectedSkillLevel) || 0;
							let actualSkill = Number(skill.skillLevel) || 0;
							if (expected > 100) {
								expected = 100;
							}
							if (actualSkill > 100) {
								actualSkill = 100;
							}
							let percentage = (actualSkill / expected) * 100;
							if (percentage > 100) {
								percentage = 100;
							}
							totalSkill += percentage;
							skill.percentage = percentage;
							let value =  null; //skill.skillLevel;
							// if (this.updatedCompetencyData) {
							// 	const skillLevel = this.updatedCompetencyData.find((items => items.skillID === skill.ID))
							// 	if (skillLevel){
							// 		value = skillLevel.skillLevel;
							// 	}
							// } else {
							// 	value = null; 
							// }
							const weightage: WeightageModel = {
								fieldCaption: skill.name,
								fieldColumn: skill.ID,
								additionalMetaData: {
									maxWeightage: skillLevelData,
									// minWeightage: 1,
									showHelp: true,
									expectedWeightage: null,
									defaultWeightage: 0
								},
								fieldType: 'weightage',
								isHidden: false,
								isReadonly: false,
								isRequired: false,
								value
							};
							this.formFields = [
								title,
								weightage
							];
							skill.field = weightage;
							this.builderService.fieldModelBuilder(this.formFields);
							const control: UntypedFormControl = this.builderService.controlBuilder(weightage);
							skill.control = control;
							control.valueChanges.subscribe(controlResp => {
								this.updateSkill(skill.ID, controlResp);
							});
						}
						if (totalSkill) {
							competency.avg = totalSkill / competency.skills.length;
						}
					}
				}
			}
		} else if (action === 'sharing') {
			for (const record of data) {
				if (record.createdTimeStamp) {
					record.createdTimeStamp = this.gfService.dateFormat(record.createdTimeStamp, 'MMM d, y');
				}
				if (record.resourceTypeID) {
					record.resourceTypeID = this.baseService.referenceType('resourceType', record.resourceTypeID);
				}
			}
		}
	}

	addWorkgroup(actionElement?) {
		if (navigator.onLine) {
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				data: {
					action: 'dynamic',
					popup: true,
					component: WorkgroupFormsComponent,
					componentData: [
						{
							variableName: 'action',
							value: 'createWorkgroup'
						},
						{
							variableName: 'workGroupData',
							value: null
						}
					],
					triggerEl: actionElement
				},
				disableClose: true,
				maxWidth: '860px'
			});
			dialogRef.afterClosed().subscribe(async (result) => {
				if (result && typeof result === 'object') {
					this.workgroupData.push(
						{
							groupName: result.groupName,
							groupID: result.recordID
						}
					);
				}
			});
		}
	}

	addMemberToWorkgroup(data) {
		if (navigator.onLine) {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			const apiData = {
				WGID: data.groupID,
				toUserIDARRAY: [
					this.userData.userID
				],
				notificationType: 2
			};
			if (this.deviceDetails.browserName === 'Safari') {
				apiData.notificationType = 2;
			}
			const headers: any = {};
			this.workgroupApiService.saveInvites(apiData, headers).subscribe(
				(response) => {
					data.added = true;
				},
				(error) => {
					if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'DUPLICATE') {
						error.error = this.locale.translate('you_have_already_sent_invites_desc');
					}
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					if (this.helpTriggered) {
						this.loader = false;
					} else {
						this.popupRef.componentInstance.popupLoader = false;
					}
				});
		}
	}

	navigateToResource(data) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel', 'advanced-content'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: ResourceDetailComponent,
				componentData: [
					{
						variableName: 'actualResourceID',
						value: data.resourceID
					}
				]
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
			}
		});
	}

	updateCertificationStatus(action) {
		const apiData: any = {
			// userID: this.userID
		};
		const headers: any = {};
		let msg = '';
		let finalStatus;

		const certificationStatus = this.baseService.certificationStatus;
		for (const status of certificationStatus) {
			if (status.key === 'published' && action === 'accept') {
				apiData.status = status.value;
			} else if (status.key === 'rejected' && action === 'rejectCertification') {
				apiData.status = status.value;
			}
		}

		if (action === 'accept') {
			// apiData.status = 1;
			msg = 'certificate_published';
			finalStatus = this.baseService.certificationStatus.find(items => items.key === 'published');
		} else {
			// apiData.status = 3;
			msg = 'certificate_rejected';
			finalStatus = this.baseService.certificationStatus.find(items => items.key === 'rejected');
		}
		this.popupRef.componentInstance.popupLoader = true;
		this.apiService.moderateCertificate(apiData, this.data.registerLearningID, headers).subscribe(
			(response) => {
				if (this.popupRef && this.popupRef.componentInstance) {
					this.popupRef.componentInstance.dialogCloseData = {
						updated: true
					};
				}
				this.data.status = finalStatus;
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate(msg),
					icon: 'check_circle_outline',
					position: 'before'
				});
				if (this.data && !this.data.isMyWorkGroupMember) {
					this.workgroupProcess();
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.popupRef.componentInstance.popupLoader = false;
			});
	}

	workgroupProcess() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: PeopleFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'workgroupProcess'
					},
					{
						variableName: 'userID',
						value: this.userID
					},
					{
						variableName: 'userData',
						value: this.userData
					},
					{
						variableName: 'record',
						value: this.record
					}
				]
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
			}
		});
	}

	getFeedback(pageNumber) {
		const headers: any = {};
		const apiData = {
			userID: this.userID,
			limit: 10,
			pageNumber
		};
		this.apiService.getFeedback(apiData, headers).subscribe(
			(response) => {
				if (response && Array.isArray(response.records)) {
					this.totalRecordCount = response.totalRecordCount;
					for (const data of response.records) {
						if (data.feedbacker) {
							data.feedbacker.name = `${data.feedbacker.firstName}${data.feedbacker.lastName
								? ' ' + data.feedbacker.lastName
								: ''}`;
						}
						data.date = this.gfService.dateFormat(data.createdAt, 'MMM d, y');
						this.feedbackData.push(data);
					}
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.popupRef.componentInstance.popupLoader = false;
			});
	}

	updateSkill(ID, level) {
		if (navigator.onLine) {
			const apiData = {
				skill: ID,
				skillLevel: level,
				userID: this.userID
			};
			const headers: any = {};
			this.apiService.updateSkill(apiData, headers).subscribe(
				(response) => {
					if (this.popupRef) {
						this.popupRef.componentInstance.dialogCloseData = {
							reload: true
						};
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => { });
		}
	}

	tabChange(event: MatTabChangeEvent) {
		if (event && event.tab && event.tab.content && event.tab.content.viewContainerRef && event.tab.content.viewContainerRef.element && event.tab.content.viewContainerRef.element.nativeElement) {
			const el: HTMLElement = event.tab.content.viewContainerRef.element.nativeElement;
			if (el.dataset && el.dataset.key) {
				this.tabKey = el.dataset.key;
				this.getEndorsementDataForCompetency(el.dataset.key);
			}
		}
		// this.tabIndex = index;
		// this.getEndorsementDataForCompetency();
	}

	getEndorsementDataForCompetency(key) {
		let apiData: any = {};
		if (key === 'certifications' && !this.certificationData.length) {
			this.loader = true;
			const headers: any = {};
			apiData = {
				// userID: this.userID
			};
			if (this.record) {
				if (this.record.roleID) {
					apiData.roleID = this.record.roleID;
				}
				if (this.record.ID) {
					apiData.competencyID = this.record.ID;
				}
				if (this.record.actionFrom) {
					if (this.record.actionFrom === 'skill') {
						delete apiData.competencyID;
						apiData.skillID = this.record.ID;
					}
				}
			}
			let apiMethod = this.apiService.getCertification(apiData, this.userID, headers);
			if (!apiData.competencyID && !apiData.skillID) {
				apiMethod = this.apiService.getCertification({}, this.userID, headers);
			}
			this.certificationData = [];
			apiMethod.subscribe(
				(response) => {
					if (response && Array.isArray(response.records)) {
						this.certificationData = response.records;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.submitDisable = false;
					this.loader = false;
				});
		} else if (key === 'managers' && !this.endorsementManagersData.length) {
			this.loader = true;
			this.endorsementManagersData = [];
			apiData = {
				userID: this.userID,
				userType: 'manager'
			};
			if (this.record) {
				if (this.record.roleID) {
					apiData.roleID = this.record.roleID;
				}
				if (this.record.ID) {
					apiData.competencyID = this.record.ID;
				}
				if (this.record.actionFrom) {
					if (this.record.actionFrom === 'skill') {
						delete apiData.competencyID;
						apiData.skillID = this.record.ID;
					}
				}
			}
			const headers: any = {};
			this.apiService.getEndorsementDetail(apiData, headers).subscribe(
				(response) => {
					if (response && Array.isArray(response.records)) {
						for (const data of response.records) {
							data.name = `${data.firstName}${data.lastName
								? ' ' + data.lastName : ''}`;
							if (data.endorsement) {
								data.endorsement.createdAt = this.gfService.dateFormat(data.endorsement.createdAt, 'MMM d, y');
								data.endorsement.relationship = this.baseService.referenceType('relationShip', data.endorsement.relationship);
								data.endorsement.showTooltip = true;
								if (this.userID === this.currentUser.userID || !this.baseService.checkAccessControl(['MU001', 'BU001', 'MFB001']) || !data.isMyWorkGroupMember) {
									delete data.endorsement.skillLevel;
									delete data.endorsement.expectedSkillLevel;
									data.endorsement.showTooltip = false;
								}
							}
						}
						this.endorsementManagersData = response.records;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.submitDisable = false;
					this.loader = false;
				});
		} else if (key === 'peers' && !this.endorsementPeersData.length) {
			this.loader = true;
			this.endorsementPeersData = [];
			apiData = {
				userID: this.userID,
				userType: 'peer'
			};
			if (this.record) {
				if (this.record.roleID) {
					apiData.roleID = this.record.roleID;
				}
				if (this.record.ID) {
					apiData.competencyID = this.record.ID;
				}
				if (this.record.actionFrom) {
					if (this.record.actionFrom === 'skill') {
						delete apiData.competencyID;
						apiData.skillID = this.record.ID;
					}
				}
			}
			const headers: any = {};
			this.apiService.getEndorsementDetail(apiData, headers).subscribe(
				(response) => {
					if (response && Array.isArray(response.records)) {
						for (const data of response.records) {
							data.name = `${data.firstName}${data.lastName
								? ' ' + data.lastName : ''}`;
							if (data.endorsement) {
								data.endorsement.createdAt = this.gfService.dateFormat(data.endorsement.createdAt, 'MMM d, y');
								data.endorsement.relationship = this.baseService.referenceType('relationShip', data.endorsement.relationship);
								data.endorsement.showTooltip = true;
								if (this.userID === this.currentUser.userID || !this.baseService.checkAccessControl(['MU001', 'BU001', 'MFB001']) || !data.isMyWorkGroupMember) {
									delete data.endorsement.skillLevel;
									delete data.endorsement.expectedSkillLevel;
									data.endorsement.showTooltip = false;
								}
							}
						}
						this.endorsementPeersData = response.records;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.submitDisable = false;
					this.loader = false;
				});
		} else if (key === 'assessments' && !this.assessmentData.length) {
			this.loader = true;
			const headers: any = {};
			apiData = {
				userID: this.userID
			};
			if (this.record) {
				if (this.record.ID) {
					apiData.competencyID = this.record.ID;
				}
				if (this.record.actionFrom) {
					if (this.record.actionFrom === 'skill') {
						delete apiData.competencyID;
						apiData.skillID = this.record.ID;
					}
				}
			}
			this.assessmentData = [];
			this.apiService.getInternalAssessment(apiData, headers).subscribe(
				(response) => {
					if (response && Array.isArray(response.records)) {
						for (const record of response.records) {
							if (record.timeStamp) {
								record.timeStamp = this.gfService.dateFormat(record.timeStamp, 'MMM d, y');
							}
						}
						this.assessmentData = response.records;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.submitDisable = false;
					this.loader = false;
				});
		} else if (key === 'sharing' && !this.sharingData.length) {
			this.loader = true;
			const headers: any = {};
			apiData = {
				userID: this.userID
			};
			if (this.record) {
				if (this.record.ID) {
					apiData.competencyID = this.record.ID;
				}
				if (this.record.actionFrom) {
					if (this.record.actionFrom === 'skill') {
						delete apiData.competencyID;
						apiData.skillID = this.record.ID;
					}
				}
			}
			this.sharingData = [];
			this.apiService.getSharingForCompetency(apiData, headers).subscribe(
				(response) => {
					if (response && Array.isArray(response.records)) {
						this.dataBuild(response.records, 'sharing');
						this.sharingData = response.records;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.submitDisable = false;
					this.loader = false;
				});
		}
	}

	registerLearning(actionElement) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: PeopleFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'addCertification'
					},
					{
						variableName: 'userID',
						value: this.userID
					}
				],
				triggerEl: actionElement
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				this.certificationData = [];
				this.getEndorsementDataForCompetency('certifications');
			}
		});
	}

	addAssessment(actionElement) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: PeopleFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'addAssessment'
					},
					{
						variableName: 'userID',
						value: this.userID
					}
				],
				triggerEl: actionElement
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				this.assessmentData = [];
				this.getEndorsementDataForCompetency('assessments');
			}
		});
	}

	shareKnowledgeBead(actionElement) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: BeadComponent,
				componentData: [
					{
						variableName: 'tabIndex',
						value: 0
					},
					{
						variableName: 'action',
						value: 'share'
					}
				],
				triggerEl: actionElement
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				this.sharingData = [];
				this.getEndorsementDataForCompetency('sharing');
			}
		});
	}

	answerQuestion(actionElement) {

	}

	loadMySkills(skills) {
		const apiData = {};
		const headers: any = {};
		let selectedValue = [];
		if (skills.selectedValue && skills.selectedValue.length) {
			skills.selectedValue.map(items => {
				if (items.isAdd && !items.isDelete) {
					selectedValue.push((this.action === 'addInterests') ? items.key : items.key.key);
				}
			});
		}
		skills.options = [];
		this.globalApiService.getMySkills(apiData, headers).subscribe(
			(response) => {
				if (response && Array.isArray(response.records)) {
					if (selectedValue.length) {
						response.records = response.records.filter(items => {
							if (!selectedValue.includes(items.termID)) {
								return items;
							}
						});
					}
					skills.options = response.records.map(resp => {
						if (this.action === 'addCertification') {
							resp.termID = resp.skill;
						}
						return {
							key: (this.action === 'addInterests') ? resp.skill : resp,
							value: resp.skillName
						};
					});
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
			});
	}

	loadDesignation(designation) {
		designation.options = [];
		const apiData = {
			termsetid: 5
		};
		const headers: any = {};
		this.globalApiService.getTerm(apiData, headers).subscribe(
			(response) => {
				if (response && response.records.length) {
					designation.options = response.records.map(resp => {
						return {
							key: resp.termID,
							value: resp.term
						};
					});
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => { });
	}

	formObjectReader(record) {
		if (['addCertification', 'addInterests', 'updateCertification', 'addAssessment'].includes(this.action)) {
			let subscribe;
			let titleSubscribe;
			let activityTypeSubscribe;
			const form: UntypedFormGroup = record.form;
			if (form.controls.title) {
				form.controls.title.valueChanges.subscribe(controlResp => {
					if (navigator.onLine) {
						if (titleSubscribe && !titleSubscribe['closed']) {
							titleSubscribe.unsubscribe();
						}
						if (this.clearTimeout) {
							clearTimeout(this.clearTimeout);
						}
						this.clearTimeout = setTimeout(() => {
							if (controlResp && this.validationRegex.test(controlResp)) {
								const apiData = {
									url: controlResp
								};
								const header: any = {};
								form.controls.title.disable({ emitEvent: false });
								titleSubscribe = this.globalApiService.getEmbedData(apiData, header).subscribe(
									(response) => {
										if (response) {
											form.controls.title.patchValue(response.title, { emitEvent: false });
											this.embedData = response;
											this.titleField.fieldIcon = {
												suffix: {
													icon: 'clear'
												}
											}
											const issuingAuthority = this.formFields.find((items) => items.fieldColumn === 'issuingAuthority');
											if (issuingAuthority && this.formObject && this.formObject.form && this.formObject.form.controls && this.formObject.form.controls.issuingAuthority.enabled) {
												let patchValue;
												const link = new URL(this.embedData.link);
												patchValue = link.hostname.split('.');
												if (link.hostname && link.hostname.split('.').length) {
													patchValue = link.hostname.split('.')[1];
												}
												issuingAuthority.selectedValue = [
													{
														isAdd: true,
														isDelete: false,
														value: patchValue
													}
												];
												issuingAuthority.value = issuingAuthority.selectedValue;
												this.formObject.form.controls.issuingAuthority.patchValue(issuingAuthority.value, { emitEvent: false });
											}
										} else {
											this.embedData = null;
										}
									},
									(error) => {
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										this.embedData = null;
									}
								).add(() => {
									form.controls.title.enable({ emitEvent: false });
								});
							} else {
								// this.embedData = null;
							}
						}, this.appInit.configuration.searchDelay);
					}
				});
			}
			if (form.controls.issuingAuthority) {
				const issuingAuthority = this.formFields.find((items) => items.fieldColumn === 'issuingAuthority');
				form.controls.issuingAuthority.valueChanges.subscribe((controlResp) => {
					if (navigator.onLine) {
						if (subscribe && !subscribe['closed']) {
							subscribe.unsubscribe();
						}
						if (this.clearTimeout) {
							clearTimeout(this.clearTimeout);
						}
						this.clearTimeout = setTimeout(() => {
							if (controlResp && typeof controlResp === 'string') {
								const apiData = {
									searchString: controlResp,
									termsetid: 18
								};
								const header: any = {};
								let selectedValue = [];
								if (issuingAuthority.selectedValue.length) {
									issuingAuthority.selectedValue.map(items => {
										if (items.isAdd && !items.isDelete) {
											selectedValue.push(items.key.termID);
										}
									});
								}
								subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
									(response) => {
										if (response && response.records.length) {
											if (selectedValue.length) {
												response.records = response.records.filter(items => {
													if (!selectedValue.includes(items.termID)) {
														return items;
													}
												});
											}
											issuingAuthority.options = response.records.map((data) => {
												return {
													key: data,
													value: data.term
												};
											});
										} else {
											issuingAuthority.options = [];
										}
									},
									(error) => {
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										issuingAuthority.options = [];
									}
								);
							} else {
								if (typeof controlResp === 'object') {
									issuingAuthority.options = [];
								}
							}
						}, this.appInit.configuration.searchDelay);
					}
				});
			}
			if (form.controls.skills) {
				const skills = this.formFields.find((items) => items.fieldColumn === 'skills');
				form.controls.skills.valueChanges.subscribe((controlResp) => {
					if (navigator.onLine) {
						if (subscribe && !subscribe['closed']) {
							subscribe.unsubscribe();
						}
						if (this.clearTimeout) {
							clearTimeout(this.clearTimeout);
						}
						if (!controlResp) {
							if (this.action === 'addCertification' || this.action === 'updateCertification') {
								this.loadMySkills(skills);
							}
						}
						this.clearTimeout = setTimeout(() => {
							if (controlResp && typeof controlResp === 'string') {
								const apiData = {
									searchString: controlResp,
									termsetid: 1
								};
								const header: any = {};
								let selectedValue = [];
								if (skills.selectedValue.length) {
									skills.selectedValue.map(items => {
										if (items.isAdd && !items.isDelete) {
											selectedValue.push((this.action === 'addInterests') ? items.key : items.key.key);
										}
									});
								}
								subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
									(response) => {
										if (response && response.records.length) {
											if (selectedValue.length) {
												response.records = response.records.filter(items => {
													if (!selectedValue.includes(items.termID)) {
														return items;
													}
												});
											}
											skills.options = response.records.map((data) => {
												return {
													key: (this.action === 'addInterests') ? data.termID : data,
													value: data.term
												};
											});
										} else {
											skills.options = [];
										}
									},
									(error) => {
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										skills.options = [];
									}
								);
							} else {
								if (typeof controlResp === 'object' && controlResp) {
									skills.options = [];
								}
							}
						}, this.appInit.configuration.searchDelay);
					}
				});
			}

			if (form.controls.activityType) {
				form.controls.activityType.valueChanges.subscribe(controlResp => {
					if (navigator.onLine) {
						if (activityTypeSubscribe && !activityTypeSubscribe['closed']) {
							activityTypeSubscribe.unsubscribe();
						}
						const issuingAuthority = this.formFields.find((items) => items.fieldColumn === 'issuingAuthority');
						const date = this.formFields.find((items) => items.fieldColumn === 'date');
						if (controlResp) {
							// const resourceType = this.baseService.referenceType('resourceType', controlResp);
							// console.log(resourceType)
							if (controlResp === 1) {
								issuingAuthority.isHidden = false;
								issuingAuthority.isRequired = true;
								date.isHidden = true;
								form.controls.issuingAuthority.enable();
								form.controls.date.disable();
								form.controls.date.patchValue(null);
								if (this.embedData) {
									let patchValue;
									const link = new URL(this.embedData.link);
									patchValue = link.hostname.split('.');
									if (link.hostname && link.hostname.split('.').length) {
										patchValue = link.hostname.split('.')[1];
									}
									issuingAuthority.selectedValue = [
										{
											isAdd: true,
											isDelete: false,
											value: patchValue
										}
									];
									issuingAuthority.value = issuingAuthority.selectedValue;
									form.controls.issuingAuthority.patchValue(issuingAuthority.value, { emitEvent: false });
								}
							} else if (controlResp === 2) {
								date.isHidden = false;
								date.isRequired = true;
								issuingAuthority.isHidden = true;
								form.controls.date.enable();
								form.controls.issuingAuthority.disable();
								form.controls.issuingAuthority.patchValue(null);
								issuingAuthority.selectedValue = [];
							}
						}

					}
				});
			}
			let tagUserSubscribe;
			const tagUser = record.fields.find((items) => items.fieldColumn === 'taggedUsers');
			if (form.controls.taggedUsers) {
				form.controls.taggedUsers.valueChanges.subscribe((controlResp) => {
					if (navigator.onLine) {
						if (tagUserSubscribe && !tagUserSubscribe['closed']) {
							tagUserSubscribe.unsubscribe();
						}
						if (this.clearTimeout) {
							clearTimeout(this.clearTimeout);
						}
						this.clearTimeout = setTimeout(() => {
							if (controlResp && typeof controlResp === 'string') {
								const apiData = {
									searchString: controlResp
								};
								const header: any = {};
								let selectedValue = [];
								if (tagUser.selectedValue.length) {
									tagUser.selectedValue.map(items => {
										if (items.isAdd && !items.isDelete) {
											selectedValue.push(items.key);
										}
									});
								}
								tagUserSubscribe = this.globalApiService.getUsers(apiData, header).subscribe(
									(response) => {
										if (response && response.records.length) {
											if (selectedValue.length) {
												response.records = response.records.filter(items => {
													if (!selectedValue.includes(items.userID)) {
														return items;
													}
												});
											}
											tagUser.options = response.records.map((data) => {
												return {
													key: data.userID,
													value: `${data.firstName}${data.lastName
														? ' ' + data.lastName
														: ''}`,
													prefix: {
														type: 'image',
														value: data.profilePicURL
													},
													shortInfo: this.baseService.getUserShortInfo(data)
												};
											});
										} else {
											tagUser.options = [];
										}
									},
									(error) => {
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										tagUser.options = [];
									}
								);
							} else {
								if (typeof controlResp === 'object') {
									tagUser.options = [];
								}
							}
						}, this.appInit.configuration.searchDelay);
					}
				});

			}
		}
		if (record.form && record.form.controls.users) {
			const usersField = record.fields.find((items) => items.fieldColumn === 'users');
			let subscribe;
			record.form.controls.users.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							// const userFilter: any = { $and: [] };
							// const splitVal = controlResp.toLowerCase().split(' ');
							// for (const value of splitVal) {
							//   userFilter.$and.push({
							//     $or: {
							//       '$accountDetail.firstName$': { $substring: value },
							//       '$accountDetail.lastName$': { $substring: value }
							//     }
							//   });
							// }
							const apiData = {
								searchString: controlResp
							};
							const header: any = {};
							let selectedValue = [];
							if (usersField.selectedValue.length) {
								usersField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getParentPublisher(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.userID)) {
													return items;
												}
											});
										}
										usersField.options = response.records.map((data) => {
											return {
												key: data.userID,
												value: `${data.firstName}${data.lastName
													? ' ' + data.lastName
													: ''}`,
												prefix: {
													type: 'image',
													value: data.profilePicURL
												},
												shortInfo: this.baseService.getUserShortInfo(data)
											};
										});
									} else {
										usersField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									usersField.options = [];
								}
							);
						} else {
							usersField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		if (['create', 'update', 'inviteUser'].includes(this.action)) {
			const form: UntypedFormGroup = record.form;
			let departmentSubscribe;
			let designationSubscribe;
			let locationSubscribe;
			let citySubscribe;
			if (form.controls.department) {
				let department;
				if (this.action !== 'inviteUser') {
					department = this.formFields.find((items) => items.fieldColumn === 'department');
				} else {
					department = this.department;
				}
				form.controls.department.valueChanges.subscribe((controlResp) => {
					if (navigator.onLine) {
						if (departmentSubscribe && !departmentSubscribe['closed']) {
							departmentSubscribe.unsubscribe();
						}
						if (this.clearTimeout) {
							clearTimeout(this.clearTimeout);
						}
						this.clearTimeout = setTimeout(() => {
							if (controlResp && typeof controlResp === 'string') {
								const apiData = {
									searchString: controlResp,
									termsetid: 7
								};
								const header: any = {};
								let selectedValue = [];
								// if (department.selectedValue.length) {
								// 	department.selectedValue.map(items => {
								// 		if (items.isAdd && !items.isDelete) {
								// 			selectedValue.push(items.key);
								// 		}
								// 	});
								// }
								departmentSubscribe = this.globalApiService.getTerm(apiData, header).subscribe(
									(response) => {
										if (response && response.records.length) {
											if (selectedValue.length) {
												response.records = response.records.filter(items => {
													if (!selectedValue.includes(items.termID)) {
														return items;
													}
												});
											}
											department.options = response.records.map((data) => {
												return {
													key: data.termID,
													value: data.term
												};
											});
										} else {
											department.options = [];
										}
									},
									(error) => {
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										department.options = [];
									}
								);
							} else {
								department.options = [];
							}
						}, this.appInit.configuration.searchDelay);
					}
				});
			}
			if (form.controls.designation) {
				const designation = this.formFields.find((items) => items.fieldColumn === 'designation');
				form.controls.designation.valueChanges.subscribe((controlResp) => {
					if (navigator.onLine) {
						if (designationSubscribe && !designationSubscribe['closed']) {
							designationSubscribe.unsubscribe();
						}
						if (this.clearTimeout) {
							clearTimeout(this.clearTimeout);
						}
						this.clearTimeout = setTimeout(() => {
							if (controlResp && typeof controlResp === 'string') {
								const apiData = {
									searchString: controlResp,
									termsetid: 5
								};
								const header: any = {};
								let selectedValue = [];
								// if (designation.selectedValue.length) {
								// 	designation.selectedValue.map(items => {
								// 		if (items.isAdd && !items.isDelete) {
								// 			selectedValue.push(items.key);
								// 		}
								// 	});
								// }
								designationSubscribe = this.globalApiService.getTerm(apiData, header).subscribe(
									(response) => {
										if (response && response.records.length) {
											if (selectedValue.length) {
												response.records = response.records.filter(items => {
													if (!selectedValue.includes(items.termID)) {
														return items;
													}
												});
											}
											designation.options = response.records.map((data) => {
												return {
													key: data.termID,
													value: data.term
												};
											});
										} else {
											designation.options = [];
										}
									},
									(error) => {
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										designation.options = [];
									}
								);
							} else {
								if (typeof controlResp === 'object') {
									designation.options = [];
								} else {
									this.loadDesignation(designation);
								}
							}
						}, this.appInit.configuration.searchDelay);
					}
				});
			}

			if (form.controls.location) {
				let location;
				let city;

				if (this.action !== 'inviteUser') {
					location = this.formFields.find((items) => items.fieldColumn === 'location');
					city = this.formFields.find((items) => items.fieldColumn === 'city');
				} else {
					location = this.location;
					city = this.city;
				}

				form.controls.location.valueChanges.subscribe((controlResp) => {
					if (navigator.onLine) {
						if (locationSubscribe && !locationSubscribe['closed']) {
							locationSubscribe.unsubscribe();
						}
						if (this.clearTimeout) {
							clearTimeout(this.clearTimeout);
						}

						if ((controlResp && typeof controlResp === 'object' && controlResp.isAdd && !city.isHidden) || (!controlResp && !city.isHidden)) {
							city.isHidden = true;
							form.controls.city.disable();
						}

						if (controlResp && typeof controlResp === 'string' && form.controls.city && city.isHidden) {
							form.controls.city.patchValue(null, { emitEvent: false });
							form.controls.city.markAsUntouched();
							city.selectedValue = [];
							city.isHidden = false;
							form.controls.city.enable();
						}

						this.clearTimeout = setTimeout(() => {
							if (controlResp && typeof controlResp === 'string') {
								const apiData = {
									searchString: controlResp
								};
								const header: any = {};
								let selectedValue = [];
								// if (location.selectedValue.length) {
								// 	location.selectedValue.map(items => {
								// 		if (items.isAdd && !items.isDelete) {
								// 			selectedValue.push(items.key);
								// 		}
								// 	});
								// }
								locationSubscribe = this.apiService.getLocation(apiData, header).subscribe(
									(response) => {
										if (response && response.records.length) {
											if (selectedValue.length) {
												response.records = response.records.filter(items => {
													if (!selectedValue.includes(items.termID)) {
														return items;
													}
												});
											}
											location.options = response.records.map((data) => {
												const value = [];
												value.push(data.term);
												if (data.city) {
													if (data.city.name) {
														value.push(` ${data.city.name}`)
													}
												}
												if (data.country) {
													if (data.country.name) {
														value.push(` ${data.country.name}`)
													}
												}
												return {
													key: data.termID,
													value: value.toString()
												};
											});
										} else {
											location.options = [];
										}

									},
									(error) => {
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										location.options = [];
									}
								);
							} else {
								if (typeof controlResp === 'object') {
									location.options = [];
								}
							}
						}, this.appInit.configuration.searchDelay);
					}
				});
			}


			if (form.controls.city) {
				let city;
				if (this.action !== 'inviteUser') {
					city = this.formFields.find((items) => items.fieldColumn === 'city');
				} else {
					city = this.city;
				}
				form.controls.city.valueChanges.subscribe((controlResp) => {
					if (navigator.onLine) {
						if (citySubscribe && !citySubscribe['closed']) {
							citySubscribe.unsubscribe();
						}
						if (this.clearTimeout) {
							clearTimeout(this.clearTimeout);
						}
						this.clearTimeout = setTimeout(() => {
							if (controlResp && typeof controlResp === 'string') {
								const apiData = {
									searchString: controlResp,
									termsetid: 9
								};
								const header: any = {};
								let selectedValue = [];
								citySubscribe = this.globalApiService.getTerm(apiData, header).subscribe(
									(response) => {
										if (response && response.records.length) {
											if (selectedValue.length) {
												response.records = response.records.filter(items => {
													if (!selectedValue.includes(items.termID)) {
														return items;
													}
												});
											}
											city.options = response.records.map((data) => {
												const value = [];
												value.push(data.term);
												if (data.country) {
													if (data.country.name) {
														value.push(` ${data.country.name}`)
													}
												}
												return {
													key: data.termID,
													value: value.toString()
												};
											});
										} else {
											city.options = [];
										}
									},
									(error) => {
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										city.options = [];
									}
								);
							} else {
								if (typeof controlResp === 'object') {
									city.options = [];
								}
							}
						}, this.appInit.configuration.searchDelay);
					}
				});
			}
		}
		if (this.action !== 'inviteUser') {
			if (this.formObject) {
				this.formObject.form = new UntypedFormGroup(this.gfService.JSONMerge(this.formObject.form.controls, record.form.controls));
				this.formObject.fields = this.formObject.fields.concat(record.fields);
			} else {
				this.formObject = record;
			}
		}
	}

	embedLink(url) {
		if (navigator.onLine) {
			this.gfService.windowNavigate(url, '_blank');
		}
	}

	clearEmbed(event) {
		if (navigator.onLine) {
			this.embedData = null;
			this.formObject.form.controls.title.patchValue(null, { emitEvent: false });
			this.titleField.fieldIcon = null;
		}
	}

	alertPopup(action, data, additionalInfo: any = {}) {
		let content = '';
		let title = '';
		let buttons = [
			{
				type: 'main-action',
				caption: this.locale.translate('yes'),
				key: 'yes'
			},
			{
				type: 'main-action',
				caption: this.locale.translate('no'),
				key: 'no',
				autoFocus: true
			}
		];
		if (action === 'deleteCertification') {
			content = this.locale.translate('delete_certification_text');
			title = this.locale.translate('delete_certification');
		} else if (action === 'rejectCertification') {
			content = this.locale.translate('rejected_certification_text');
			title = this.locale.translate('reject_certification');
		}
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'alert',
				classes: 'warning',
				popup: true,
				icon: 'warning',
				title,
				content,
				buttons,
				triggerEl: additionalInfo.actionElement
			},
			disableClose: true,
			maxWidth: '560px'
		});
		dialogRef.afterClosed().subscribe((resp) => {
			if (resp) {
				if (resp.key === 'yes') {
					if (action === 'deleteCertification') {
						this.deleteCertification(data, additionalInfo);
					} else if (action === 'rejectCertification') {
						this.updateCertificationStatus('rejectCertification');
					}
				}
			}
		});
	}

	deleteCertification(data, additionalInfo) {
		const headers: any = {};
		this.popupRef.componentInstance.popupLoader = true;
		this.apiService.deleteCertification(data.registerLearningID, headers).subscribe(
			(response) => {
				this.popupRef.close({ status: 'deleted' });
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate('learning_deleted'),
					icon: 'check_circle_outline',
					position: 'before'
				});
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.popupRef.componentInstance.popupLoader = false;
			});
	}

	certificationDetail(data, additionalInfo: any = {}) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: PeopleFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'certificationDetail'
					},
					{
						variableName: 'record',
						value: data
					},
					{
						variableName: 'userID',
						value: this.userID
					},
					{
						variableName: 'userData',
						value: this.userData
					}
				]
			},
			autoFocus: false,
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				this.certificationData.splice(additionalInfo.index, 1);
			}
		});
	}

	requestEndorsement() {

	}

	submit() {
		if (navigator.onLine) {
			if (this.action === 'create') {
				this.addUser();
			} else if (this.action === 'updateThumbnail') {
				this.updateThumbnail();
			} else if (this.action === 'addCertification') {
				this.submitCertification();
			} else if (this.action === 'addInterests') {
				this.addInterests();
			} else if (this.action === 'updateCertification') {
				this.updateCertification();
			} else if (this.action === 'update') {
				this.updateUser();
			} else if (this.action === 'addAssessment') {
				this.submitAssessment();
			} else if (this.action === 'moderateCertification') {
				this.certificationModerationSubmit();
			} else if (this.action === 'inviteUser') {
				this.inviteUser();
			} else if (this.action === 'assignSkill') {
				console.log('assigned')
			}
		}
	}

	submitAssessment() {
		if (this.formObject && this.formObject.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('people');
			if (this.formObject.form.valid) {
				if (this.helpTriggered) {
					this.loader = true;
				} else {
					this.popupRef.componentInstance.popupLoader = true;
				}
				const apiData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);

				const skills = [];
				for (const skill of apiData.skills) {
					if (skill.isAdd && !skill.isDelete) {
						skills.push({
							skillID: skill.key.termID,
							skillLevel: skill.progress
						});
					}
				}
				apiData.skill = skills;
				delete apiData.skills;
				apiData.userID = this.userID;
				this.apiService
					.addInternalAssessment(apiData, headers)
					.subscribe(
						(response) => {
							this.popupRef.close(apiData);
							this.gfService.openSnackBar('SUCCESS', {
								message: this.locale.translate('internal_assessment_added'),
								icon: 'check_circle_outline',
								position: 'before'
							});
						},
						(error) => {
							this.gfService.errorHandler(error, {
								alert: {
									id: 'people'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						if (this.helpTriggered) {
							this.loader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	addInterests() {
		if (this.formObject && this.formObject.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('people');
			if (this.formObject.form.valid) {
				if (this.helpTriggered) {
					this.loader = true;
				} else {
					this.popupRef.componentInstance.popupLoader = true;
				}
				const formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);

				const skills = [];
				for (const skill of formData.skills) {
					if (skill.hasOwnProperty('key')) {
						if (skill.isAdd && !skill.isDelete) {
							skills.push(skill.key);
						}
					} else if (skill.value) {
						if (skill.value.isAdd && !skill.value.isDelete) {
							skills.push(skill.value.value);
						}
					}
				}
				const apiData = {
					skillID: skills
				};
				this.apiService
					.addInterests(apiData, headers)
					.subscribe(
						(response) => {
							this.popupRef.close(apiData);
							this.gfService.openSnackBar('SUCCESS', {
								message: this.locale.translate('interests_added'),
								icon: 'check_circle_outline',
								position: 'before'
							});
						},
						(error) => {
							if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'DUPLICATE') {
								error.error = this.locale.translate('the_skill_being_added_already_exists');
							}
							this.gfService.errorHandler(error, {
								alert: {
									id: 'people'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						if (this.helpTriggered) {
							this.loader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	submitCertification() {
		if (this.formObject && this.formObject.form) {
			this.submitDisable = true;
			this.gfService.alertClear('people');
			if (this.formObject.form.valid) {
				if (this.helpTriggered) {
					this.loader = true;
				} else {
					this.popupRef.componentInstance.popupLoader = true;
				}
				this.certificateFormObject = this.formObject;
				this.addCertification();
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	moderateCertification() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: PeopleFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'moderateCertification'
					},
					{
						variableName: 'userID',
						value: this.userID
					},
					{
						variableName: 'data',
						value: {
							formObject: this.formObject,
							embedData: this.embedData
						}
					}
				]
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: false
		});
		this.popupRef.close({ dialogRef });
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
			}
		});
	}

	certificationModerationSubmit() {
		if (this.formObject && this.formObject.form) {
			this.submitDisable = true;
			this.gfService.alertClear('people');
			if (this.formObject.form.valid) {
				if (this.helpTriggered) {
					this.loader = true;
				} else {
					this.popupRef.componentInstance.popupLoader = true;
				}
				let formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				let users = [];
				for (const data of formData.users) {
					if (data.isAdd && !data.isDelete) {
						users.push(data.key);
					}
				}
				this.addCertification(users);
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	viewCertificate() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: import('@app/modules/course/course-forms/course-forms.component'),
				componentData: [
					{
						variableName: 'action',
						value: 'viewCertificate'
					},
					{
						variableName: 'record',
						value: {
							resourceID: this.record.registerLearningID
						}
					},
					{
						variableName: 'profileCertificate',
						value: true
					}
				],
				// triggerEl: actionEl
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
			}
		});
	}

	addCertification(users = []) {
		// if(users.length>0) {

		const formData: any = this.gfService.fieldSubmitApiValueConstruct(
			this.certificateFormObject.form.getRawValue(),
			this.certificateFormObject.fields
		);
		const headers: any = {};
		const actualSkills = [];
		const skills = [];
		const issuingAuthority = [];
		const actualIssuingAuthority = [];
		if (formData.issuingAuthority) {
			for (const data of formData.issuingAuthority) {
				if (data.hasOwnProperty('key')) {
					if (data.isAdd && !data.isDelete) {
						issuingAuthority.push(data.key.termID);
						actualIssuingAuthority.push(data.key.term);
					}
				} else if (data.value) {
					if (data.value.isAdd && !data.value.isDelete) {
						issuingAuthority.push(data.value.value);
						actualIssuingAuthority.push(data.value.value);
					}
				}
			}
		}
		// for (const skill of formData.skills) {
		// 	if (skill.isAdd && !skill.isDelete) {
		// 		actualSkills.push(skill);
		// 		skills.push({
		// 			skill: skill.key.termID,
		// 			skillLevel: skill.progress
		// 		});
		// 	}
		// }
		for (const skill of formData.skills) {
			if (!skill.value && skill.isAdd && !skill.isDelete) {
				skills.push({
					skill: skill.key.termID,
					skillLevel: skill.progress
				});
			} else if (skill.value) {
				if (skill.value.isAdd && !skill.value.isDelete) {
					const skillData: any = { skillName: skill.value.value };
					if (skill.value.progress) {
						skillData.skillLevel = skill.value.progress;
					}
					skills.push(skillData);
				}
			}
		}

		formData.skills = skills;

		delete formData.issuingAuthority;
		const taggedUsers = [];
		if (formData && formData.taggedUsers) {
			for (const user of formData.taggedUsers) {
				if (user.isAdd && !user.isDelete) {
					taggedUsers.push(user.key);
				}
			}
		}
		formData.taggedUsers = taggedUsers;
		if (!taggedUsers.length) {
			delete formData.taggedUsers;
		}

		if (formData.activityType) {
			formData.activityType = formData.activityType;
		}
		if (!formData.date) {
			delete formData.date;
		} else {
			formData.date = Date.parse(formData.date);
		}
		if (issuingAuthority && issuingAuthority.length) {
			if (typeof issuingAuthority[0] === 'number') {
				formData.issuingAuthorityID = issuingAuthority[0];
			} else {
				formData.issuingAuthorityName = issuingAuthority[0];
			}
		}
		if (this.embedData) {
			formData.URL = this.embedData.link;
		}
		if (users && users.length) {
			formData.submittedTo = users[0];
		}
		if (this.record) {
			if (this.record.resourceID) {
				formData.resRef = this.record.resourceID;
			}
			if (this.record.resourceTypeID) {
				formData.refResTypeID = this.record.resourceTypeID;
			}
			if (this.record.registrationID) {
				formData.registrationID = this.record.registrationID;
			}
		}
		// this.submitDisable = false;
		// if (this.helpTriggered) {
		// 	this.loader = false;
		// } else {
		// 	this.popupRef.componentInstance.popupLoader = false;
		// }
		// return;

		const apiData = this.gfService.convertToFormData({ ...formData });

		this.apiService
			.addCertification(apiData, headers)
			.subscribe(
				async (response) => {
					this.baseService.logUserActivity('registerlearning', 'learning', ['']);
					formData.skills = actualSkills;
					formData.issuingAuthority = actualIssuingAuthority;
					this.popupRef.close(this.gfService.JSONMerge(response, formData));
					this.gfService.openSnackBar('SUCCESS', {
						message: this.locale.translate('learning_registered'),
						icon: 'check_circle_outline',
						position: 'before'
					});
				},
				(error) => {
					// if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'NOT_IN_WORKGROUP') {
					// 	this.moderateCertification();
					// }
					this.gfService.errorHandler(error, {
						alert: {
							id: 'people'
						},
						form: this.formObject.form
					});
				}
			)
			.add(() => {
				this.submitDisable = false;
				if (this.helpTriggered) {
					this.loader = false;
				} else {
					this.popupRef.componentInstance.popupLoader = false;
				}
			});
		// } else {
		// 	this.moderateCertification();
		// }
	}

	getShortInfo(columnName: string, columnValue) {
		const field = this.formFields.find((items) => items.fieldColumn === columnName);
		let value = '';
		field.options.forEach((option, index) => {
			if (option.key === columnValue) {
				value = option.value;
			}
		});
		return value;
	}

	addUser() {
		if (this.formObject && this.formObject.form) {
			this.gfService.alertClear('people');
			this.submitDisable = true;
			if (this.formObject.form.valid) {
				if (this.helpTriggered) {
					this.loader = true;
				} else {
					this.popupRef.componentInstance.popupLoader = true;
				}
				const apiData = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				const headers: any = {};
				if (apiData.experienceAtJoining) {
					const exp = apiData.experienceAtJoining.split('.');
					if (exp && exp.length) {
						const monthFromYear = Number(exp[0]) * 12;
						if (exp[1]) {
							apiData.experienceAtJoining = monthFromYear + Number(exp[1]);
						}
					}
				}
				if (apiData.department) {
					for (const department of apiData.department) {
						if (department.hasOwnProperty('key')) {
							if (department.isAdd && !department.isDelete) {
								apiData.department = department.key;
							}
						} else if (department.value) {
							if (department.value.isAdd && !department.value.isDelete) {
								delete apiData.department;
								apiData.departmentName = department.value.value;
							}
						}
					}
				}
				if (apiData.designation) {
					for (const designation of apiData.designation) {
						if (designation.hasOwnProperty('key')) {
							if (designation.isAdd && !designation.isDelete) {
								apiData.designation = designation.key;
							}
						} else if (designation.value) {
							if (designation.value.isAdd && !designation.value.isDelete) {
								delete apiData.designation;
								apiData.designationName = designation.value.value;
							}
						}
					}
				}


				if (apiData.location) {
					for (const location of apiData.location) {
						if (location.hasOwnProperty('key')) {
							if (location.isAdd && !location.isDelete) {
								apiData.locationID = location.key;
							}
						} else if (location.value) {
							if (location.value.isAdd && !location.value.isDelete) {
								delete apiData.location;
								apiData.locationName = location.value.value;
							}
						}
					}
				}

				if (apiData.city) {
					for (const city of apiData.city) {
						if (city.hasOwnProperty('key')) {
							if (city.isAdd && !city.isDelete) {
								apiData.cityID = city.key;
							}
						}
					}
				}

				if (!apiData.experienceAtJoining) {
					delete apiData.experienceAtJoining;
				}

				delete apiData.city;
				delete apiData.location;
				this.apiService
					.add(apiData, headers)
					.subscribe(
						(response) => {
							if (response) {
								// apiData.designationName = this.getShortInfo('designation', apiData.designation);
								// apiData.departmentName = this.getShortInfo('department', apiData.department);
								// apiData.locationName = this.getShortInfo('location', apiData.location);
								// apiData.companyName = null;
								// apiData.cityName = null;
								this.popupRef.close(this.gfService.JSONMerge(apiData, { userID: response.recordID }));
								this.gfService.openSnackBar('SUCCESS', {
									message: this.locale.translate('user_account_created'),
									icon: 'check_circle_outline',
									position: 'before'
								});
							}
						},
						(error) => {
							this.gfService.errorHandler(error, {
								alert: {
									id: 'people'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						if (this.helpTriggered) {
							this.loader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	updateThumbnail() {
		if (this.formObject && this.formObject.form) {
			this.gfService.alertClear('people');
			this.submitDisable = true;
			if (this.formObject.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				let apiData = this.gfService.JSONMerge(formValue, {
					userID: this.userID
				});
				apiData = this.gfService.convertToFormData(apiData);
				const headers: any = {};
				this.apiService
					.updateThumbnail(apiData, headers)
					.subscribe(
						async (response) => {
							if (response) {
								formValue.isProfileChanged = true;
								formValue.profilePic = await this.gfService.fileToDataURL(formValue.profilePic);
								this.popupRef.close(formValue);
								// this.gfService.openSnackBar('SUCCESS', {
								// 	message: this.locale.translate('profile_image_updated'),
								// 	icon: 'check_circle_outline',
								// 	position: 'before'
								// });
							}
						},
						(error) => {
							this.gfService.errorHandler(error, {
								alert: {
									id: 'people'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	updateCertification() {
		if (this.formObject && this.formObject.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('people');
			if (this.formObject.form.valid) {
				if (this.helpTriggered) {
					this.loader = true;
				} else {
					this.popupRef.componentInstance.popupLoader = true;
				}
				const formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				const actualSkills = [];

				const skills = [];
				for (const skill of formData.skills) {
					if (skill.isAdd && !skill.isDelete) {
						skills.push({
							skill: skill.key.termID,
							skillLevel: skill.progress
						});
						actualSkills.push(skill);
					}
				}
				formData.skills = skills;
				if (typeof formData.evidence === 'string' || [null, undefined].includes(formData.evidence.lastModified)) {
					delete formData.evidence;
				}

				if (formData.activityType) {
					formData.activityType = formData.activityType.value;
				}
				if (!formData.date) {
					delete formData.date;
				} else {
					formData.date = Date.parse(formData.date);
				}

				if (!formData.issuingAuthority) {
					delete formData.issuingAuthority;
				}

				formData.registerLearningID = this.record.registerLearningID;
				const apiData = this.gfService.convertToFormData({ ...formData });
				this.apiService
					.updateCertification(apiData, headers)
					.subscribe(
						async (response) => {
							// if (formData.evidence) {
							// 	const ext = formData.evidence.name.substring(formData.evidence.name.lastIndexOf('.') + 1).toLowerCase();
							// 	if (ext !== 'pdf') {
							// 		formData.thumbnail = await this.gfService.fileToDataURL(formData.evidence);
							// 	} else {
							// 		formData.thumbnail = 'assets/img/resource-default-image.jpg';
							// 	}
							// }
							formData.skills = actualSkills;
							this.popupRef.close(this.gfService.JSONMerge(response, formData));
							this.gfService.openSnackBar('SUCCESS', {
								message: this.locale.translate('learning_updated'),
								icon: 'check_circle_outline',
								position: 'before'
							});
						},
						(error) => {
							this.gfService.errorHandler(error, {
								alert: {
									id: 'people'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						if (this.helpTriggered) {
							this.loader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	updateUser() {
		if (this.formObject && this.formObject.form) {
			this.gfService.alertClear('people');
			this.submitDisable = true;
			if (this.formObject.form.valid) {
				if (this.helpTriggered) {
					this.loader = true;
				} else {
					this.popupRef.componentInstance.popupLoader = true;
				}
				const apiData = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				const headers: any = {};
				if (apiData.experienceAtJoining) {
					const exp = apiData.experienceAtJoining.split('.');
					if (exp && exp.length) {
						const monthFromYear = Number(exp[0]) * 12;
						if (exp[1]) {
							apiData.experienceAtJoining = monthFromYear + Number(exp[1]);
						}
					}
				}
				if (apiData.department && Array.isArray(apiData.department) && apiData.department.length) {
					for (const department of apiData.department) {
						if (!department.isDelete || (department.value && !department.value.isDelete)) {
							if (department.hasOwnProperty('key')) {
								if (department.isAdd && !department.isDelete) {
									apiData.department = department.key;
								}
							} else if (department.value) {
								if (department.value.isAdd && !department.value.isDelete) {
									delete apiData.department;
									apiData.departmentName = department.value.value;
								}
							}
						} else {
							apiData.department = null;
						}
					}
				} else {
					apiData.department = null;
				}
				if (apiData.designation && Array.isArray(apiData.designation) && apiData.designation.length) {
					for (const designation of apiData.designation) {
						if (!designation.isDelete || (designation.value && !designation.value.isDelete)) {
							if (designation.hasOwnProperty('key')) {
								if (designation.isAdd && !designation.isDelete) {
									apiData.designation = designation.key;
								}
							} else if (designation.value) {
								if (designation.value.isAdd && !designation.value.isDelete) {
									delete apiData.designation;
									apiData.designationName = designation.value.value;
								}
							}
						} else {
							apiData.designation = null;
						}
					}
				} else {
					apiData.designation = null;
				}

				if (apiData.location && Array.isArray(apiData.location) && apiData.location.length) {
					for (const location of apiData.location) {
						if (!location.isDelete || (location.value && !location.value.isDelete)) {
							if (location.hasOwnProperty('key')) {
								if (location.isAdd && !location.isDelete) {
									apiData.locationID = location.key;
								}
							} else if (location.value) {
								if (location.value.isAdd && !location.value.isDelete) {
									apiData.locationName = location.value.value;
								}
							}
						} else {
							apiData.locationID = null;
						}
					}
				} else {
					apiData.locationID = null;
				}

				apiData.cityID = null;
				if (apiData.city && Array.isArray(apiData.city) && apiData.city.length) {
					for (const city of apiData.city) {
						if (city.hasOwnProperty('key')) {
							if (city.isAdd && !city.isDelete) {
								apiData.cityID = city.key;
							}
						}
					}
				}


				delete apiData.location;
				delete apiData.city;

				if (!apiData.dateOfBirth) {
					apiData.dateOfBirth = null;
				}
				if (!apiData.dateOfJoining) {
					apiData.dateOfJoining = null;
				}
				if (!apiData.lastName) {
					apiData.lastName = null;
				}
				if (!apiData.mobileNo) {
					apiData.mobileNo = null;
				}
				if (!apiData.department) {
					apiData.department = null;
				}
				if (!apiData.experienceAtJoining) {
					apiData.experienceAtJoining = 0;
				}

				// this.submitDisable = false;
				// if (this.helpTriggered) {
				// 	this.loader = false;
				// } else {
				// 	this.popupRef.componentInstance.popupLoader = false;
				// }
				// return;
				this.apiService
					.updateUser(apiData, this.record.userID, headers)
					.subscribe(
						(response) => {
							if (response) {
								apiData.isProfileChanged = true;
								this.popupRef.close(apiData);
								this.gfService.openSnackBar('SUCCESS', {
									message: this.locale.translate('user_updated'),
									icon: 'check_circle_outline',
									position: 'before'
								});
							}
						},
						(error) => {
							this.gfService.errorHandler(error, {
								alert: {
									id: 'people'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						if (this.helpTriggered) {
							this.loader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	inviteUser() {
		if (this.formObjectData && this.formObjectData.form) {
			this.gfService.alertClear('people');
			this.submitDisable = true;
			if (this.formObjectData.form.valid) {
				if (this.helpTriggered) {
					this.loader = true;
				} else {
					this.popupRef.componentInstance.popupLoader = true;
				}
				const apiData = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				const emailIDs = [];
				if (apiData.emailID) {
					for (let data of apiData.emailID) {
						if (data.value.isAdd && !data.value.isDelete) {
							emailIDs.push(data.value.value);
						}
					}
				}

				if (apiData.department) {
					for (const department of apiData.department) {
						if (department.hasOwnProperty('key')) {
							if (department.isAdd && !department.isDelete) {
								apiData.department = department.key;
							}
						}
					}
					if (Array.isArray(apiData.department)) {
						delete apiData.department;
					}
				} else {
					delete apiData.department;
				}

				if (apiData.location && Array.isArray(apiData.location) && apiData.location.length) {
					for (const location of apiData.location) {
						if (location.hasOwnProperty('key')) {
							if (location.isAdd && !location.isDelete) {
								apiData.location = location.key;
							}
						} else if (location.value) {
							if (location.value.isAdd && !location.value.isDelete) {
								delete apiData.location;
								apiData.locationName = location.value.value;
							}
						}
					}
				} else {
					delete apiData.location;
				}


				if (apiData.city) {
					for (const city of apiData.city) {
						if (city.hasOwnProperty('key')) {
							if (city.isAdd && !city.isDelete) {
								apiData.city = city.key;
							}
						}
					}
				}

				if ((apiData.city && Array.isArray(apiData.city)) || !apiData.city) {
					delete apiData.city;
				}

				apiData.emailID = emailIDs;
				// const emailID = apiData.emailID.split(' ');
				// if (emailID && emailID.length) {
				// 	apiData.emailID = [emailID[0]];
				// }
				const headers: any = {};
				this.apiService
					.inviteUsers(apiData, headers)
					.subscribe(
						(response) => {
							if (response) {
								this.popupRef.close(apiData);
								this.gfService.openSnackBar('SUCCESS', {
									message: this.locale.translate('invitation_sent'),
									icon: 'check_circle_outline',
									position: 'before'
								});
							}
						},
						(error) => {
							this.gfService.errorHandler(error, {
								alert: {
									id: 'people'
								},
								form: this.formObjectData.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						if (this.helpTriggered) {
							this.loader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	getDetail(additionalData: any = {}) {
		if (this.action === 'userFilter') {
			this.popupRef.close({ data: this.data, index: additionalData.index });
		}
	}

	manageFunctionalRoles() {
		if (this.popupRef) {
			this.popupRef.close('close');
		}
		this.gfService.routeNavigation('/functional-roles');
	}

	userDetail(data) {
		if (data.userID) {
			if (data.userID !== this.userID) {
				this.baseService.userDetail(data.userID);
			}
		}
	}

	loadFunctionalRole() {
		const functionRoleApiData = {
			limit: 100,
			pageNumber: 1
		};
		const functionRoleHeaders: any = {};
		this.skillCompetencyApiService.roleMappingList(functionRoleApiData, functionRoleHeaders).subscribe(
			(response) => {
				if (response && response.records.length) {
					this.functionalRole.options = response.records.map(resp => {
						return {
							key: resp.termID,
							value: resp.term
						};
					});
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => { });
	}

	loadPermissionGroup() {
		const permissionGroupApiData = {
			// forRole: 0
			// limit: 100,
			// pageNumber: 1
		};
		const permissionGroupHeaders: any = {};
		this.functionRoleApiService.list(permissionGroupApiData, permissionGroupHeaders).subscribe(
			(response) => {
				if (response && response.records.length) {
					this.permissionGroup.options = response.records.map(resp => {
						return {
							key: resp.termID,
							value: resp.term
						};
					});
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => { });
	}

	addRole() {
		// this.popupRef.close('close');
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: FunctionalRolesFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'add'
					}
				]
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				this.loadFunctionalRole();
			}
		});
	}


	getUserAnalytics() {
		const headers: any = {};
		this.apiService.userAnalytics(this.userID, headers).subscribe(
			(response) => {
				if (response) {
					if (!response.skillMatch) {
						response.skillMatch = 0;
					}
					this.dataBuildAnalytics('analytics', response);
					this.analyticsData = response;
					this.cdref.detectChanges();
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
		.add(() => {
			// this.analyticsLoader = false;
		});
	}

	dataBuildAnalytics(action, records: any) {
		if (action === 'analytics') {
			let data = records;
			data.badge = this.baseService.referenceType('badgeStatus', data.badge);
			let pieChartData: PieChartModel;
			let pieChartOptions: PieOptionsModel = {
				legend: {
					display: false
				},
				tooltips: {
					enabled: false
				},
				animation: {
					duration: 0 // general animation time
				},
				hover: {
					animationDuration: 0 // duration of animations when hovering an item
				},
				responsiveAnimationDuration: 0, // animation duration after a resize
				showTooltips: false,
				disablePointerEvents: true,
				maintainAspectRatio: false
			};
			pieChartData = {
				labels: ['', ''],
				datasets: [
					{
						label: '',
						data: [data.skillUnMatch, data.skillMatch],
						backgroundColor: ['#cfe2f3', '#4a86e8'],
						borderColor: [
							'#cfe2f3',
							"#4a86e8"
						],
						borderWidth: [1, 1]
					}
				]
			};
			data.pieChartData = pieChartData;
			data.pieChartOptions = pieChartOptions;
			if (data.learning && data.learning.length) {
				const labels = [];
				for (const line of data.learning) {
					labels.push('');
				}
				// data.learning[2] = 5;
				let learningChart: LineChartModel = {
					datasets: [
						{
							data: data.learning,
							label: ['tesmp'],
							borderColor: '#5377d9',
							backgroundColor: "#a5c2f4",
							fill: true,
							borderWidth: 1
						}
					],
					labels
				};
				let learningOptions: LineOptionsModel = {
					legend: {
						display: false
					},
					tooltips: {
						enabled: false
					},
					scales: {
						yAxes: [
							{
								ticks: {
									display: false,
									beginAtZero: true
								},
								gridLines: {
									display: false,
									tickMarkLength: false
								}
							}
						],
						xAxes: [
							{
								ticks: {
									display: false,
									beginAtZero: true
								},
								gridLines: {
									display: false,
									tickMarkLength: false
								}
							}
						]
					},
					maintainAspectRatio: false,
					disablePointerEvents: true,
					bezierCurve: false,
					animation: {
						duration: 0 // general animation time
					},
					hover: {
						animationDuration: 0 // duration of animations when hovering an item
					},
					responsiveAnimationDuration: 0, // animation duration after a resize
					showTooltips: false,
					elements: {
						line: {
							tension: 0
						},
						point: {
							radius: 0
						}
					}
				};
				data.learningChart = learningChart;
				data.learningOptions = learningOptions;
			}
			if (data.engagement && data.engagement.length) {
				const labels = [];
				for (const line of data.engagement) {
					labels.push('');
				}
				let engagementChart: LineChartModel = {
					datasets: [
						{
							data: data.engagement,
							label: [],
							borderColor: '#c4971a',
							backgroundColor: "#ffd966",
							fill: true,
							borderWidth: 1
						}
					],
					labels
				};
				let engagementOptions: LineOptionsModel = {
					legend: {
						display: false
					},
					tooltips: {
						enabled: false
					},
					scales: {
						yAxes: [
							{
								ticks: {
									display: false,
									beginAtZero: true
								},
								gridLines: {
									display: false,
									tickMarkLength: false
								}
							}
						],
						xAxes: [
							{
								ticks: {
									display: false,
									beginAtZero: true
								},
								gridLines: {
									display: false,
									tickMarkLength: false
								}
							}
						]
					},
					maintainAspectRatio: false,
					disablePointerEvents: true,
					bezierCurve: false,
					animation: {
						duration: 0 // general animation time
					},
					hover: {
						animationDuration: 0 // duration of animations when hovering an item
					},
					responsiveAnimationDuration: 0, // animation duration after a resize
					showTooltips: false,
					elements: {
						line: {
							tension: 0
						},
						point: {
							radius: 0
						}
					}
				};
				data.engagementChart = engagementChart;
				data.engagementOptions = engagementOptions;
			}
			if (data.myWorkgroupLearning && data.myWorkgroupLearning.length) {
				const labels = [];
				for (const line of data.myWorkgroupLearning) {
					labels.push('');
				}
				let myWorkgroupLearningChart: LineChartModel = {
					datasets: [
						{
							data: data.myWorkgroupLearning,
							label: [],
							borderColor: '#5377d9',
							backgroundColor: "#a5c2f4",
							fill: true,
							borderWidth: 1
						}
					],
					labels
				};
				let myWorkgroupLearningOptions: LineOptionsModel = {
					legend: {
						display: false
					},
					tooltips: {
						enabled: false
					},
					scales: {
						yAxes: [
							{
								ticks: {
									display: false,
									beginAtZero: true
								},
								gridLines: {
									display: false,
									tickMarkLength: false
								}
							}
						],
						xAxes: [
							{
								ticks: {
									display: false,
									beginAtZero: true
								},
								gridLines: {
									display: false,
									tickMarkLength: false
								}
							}
						]
					},
					maintainAspectRatio: false,
					disablePointerEvents: true,
					animation: {
						duration: 0 // general animation time
					},
					hover: {
						animationDuration: 0 // duration of animations when hovering an item
					},
					responsiveAnimationDuration: 0, // animation duration after a resize
					bezierCurve: false,
					elements: {
						line: {
							tension: 0
						},
						point: {
							radius: 0
						}
					}
				};
				data.myWorkgroupLearningChart = myWorkgroupLearningChart;
				data.myWorkgroupLearningOptions = myWorkgroupLearningOptions;
			}
			if (data.myWorkgroupEngagement && data.myWorkgroupEngagement.length) {
				const labels = [];
				for (const line of data.myWorkgroupEngagement) {
					labels.push('');
				}
				let myWorkgroupSharingChart: LineChartModel = {
					datasets: [
						{
							data: data.myWorkgroupEngagement,
							label: [],
							borderColor: '#c4971a',
							backgroundColor: "#ffd966",
							fill: true,
							borderWidth: 1
						}
					],
					labels
				};
				let myWorkgroupSharingOptions: LineOptionsModel = {
					legend: {
						display: false
					},
					tooltips: {
						enabled: false
					},
					scales: {
						yAxes: [
							{
								ticks: {
									display: false,
									beginAtZero: true
								},
								gridLines: {
									display: false,
									tickMarkLength: false
								}
							}
						],
						xAxes: [
							{
								ticks: {
									display: false,
									beginAtZero: true
								},
								gridLines: {
									display: false,
									tickMarkLength: false
								}
							}
						]
					},
					maintainAspectRatio: false,
					disablePointerEvents: true,
					animation: {
						duration: 0 // general animation time
					},
					hover: {
						animationDuration: 0 // duration of animations when hovering an item
					},
					responsiveAnimationDuration: 0, // animation duration after a resize
					bezierCurve: false,
					elements: {
						line: {
							tension: 0
						},
						point: {
							radius: 0
						}
					}
				};
				data.myWorkgroupSharingChart = myWorkgroupSharingChart;
				data.myWorkgroupSharingOptions = myWorkgroupSharingOptions;
			}
			if (data.joinedWorkgroups && data.joinedWorkgroups.length) {
				let name = [];
				for (const member of data.joinedWorkgroups) {
					const memberName = `${member.firstName}${member.lastName
						? ' ' + member.lastName
						: ''}`;
					name.push(memberName);
				}
				name = this.gfService.removeDuplicateArr(name);
				data.memberNames = this.arrToStr.transform(name);
			}
		}

	}


}



// if (this.action === 'endorsementDetail') {
// 	apiData = {
// 		userID: this.userID,
// 		skillID: this.record.skillID
// 	};
// }
